"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f98 = void 0;
exports.f98 = {
    "br": [
        20,
        22,
        77,
        106,
        214,
        285,
        377,
        382,
        389,
        390,
        393,
        404,
        443,
        444,
        450,
        452,
        455,
        472,
        479,
        501,
        507,
        529,
        540,
        545,
        549,
        559,
        567,
        900,
        1017,
        1315,
        1373,
        1472,
        1688,
        1810,
        1929,
        2260,
        2492,
        2758,
        2798,
        2804,
        2815,
        2828,
        2831,
        2835,
        2836,
        2951,
        2954,
        3056,
        3113,
        3239,
        3305,
        3333,
        3426,
        3437,
        3438,
        3474,
        3477,
        3479,
        3480,
        3628,
        3630,
        3633,
        3813,
        3831,
        3840,
        3883,
        3887,
        3914,
        3931,
        3995,
        4004,
        4022,
        4032,
        4073,
        4114,
        4149,
        4161,
        4181,
        4360,
        4513,
        4595,
        4602,
        4608,
        4610,
        4679,
        4908,
        4921,
        4938,
        4987,
        5000,
        5004,
        5006,
        5088,
        5246,
        5249,
        5270,
        5273,
        5284,
        5726,
        5947,
        5962,
        5984,
        5993,
        6009,
        6016,
        6020,
        6022,
        6025,
        6027,
        6038,
        6040,
        6042,
        6157,
        6198,
        6253,
        6256,
        6298,
        6328,
        6342,
        6345,
        6368,
        6386,
        6467,
        6533,
        6662,
        6831,
        6876,
        6917,
        6948,
        7120,
        7207,
        7242,
        7251,
        7305,
        7306,
        7328,
        7329,
        7355,
        7425,
        7463,
        7536,
        7540,
        7591,
        7668,
        7671,
        7675,
        7681,
        7683,
        7726,
        7786,
        7796,
        7801,
        7834,
        7846,
        7857,
        7893,
        7940,
        7964,
        7973,
        7993,
        8005,
        8008,
        8013,
        8094,
        8153,
        8169,
        8171,
        8194,
        8240,
        8274,
        8351,
        8386,
        8395,
        8396,
        8407,
        8409,
        8425,
        8456,
        8458,
        8486,
        8489,
        8507,
        8544,
        8579,
        8584,
        8586,
        8597,
        8600,
        8615,
        8618,
        8620,
        8666,
        8690,
        8705,
        8711,
        8718,
        8742,
        8756,
        8896,
        8899,
        8948,
        9067
    ],
    "brazil": [
        450,
        2758,
        20,
        22,
        77,
        106,
        214,
        285,
        377,
        382,
        389,
        390,
        393,
        404,
        443,
        444,
        452,
        455,
        472,
        479,
        501,
        507,
        529,
        540,
        545,
        549,
        559,
        567,
        900,
        1017,
        1315,
        1373,
        1472,
        1688,
        1810,
        1929,
        2260,
        2492,
        2798,
        2804,
        2815,
        2828,
        2831,
        2835,
        2836,
        2951,
        2954,
        3056,
        3113,
        3239,
        3305,
        3333,
        3426,
        3437,
        3438,
        3474,
        3477,
        3479,
        3480,
        3628,
        3630,
        3633,
        3813,
        3831,
        3840,
        3883,
        3887,
        3914,
        3931,
        3995,
        4004,
        4022,
        4032,
        4073,
        4114,
        4149,
        4161,
        4181,
        4360,
        4513,
        4595,
        4602,
        4608,
        4610,
        4679,
        4908,
        4921,
        4938,
        4987,
        5000,
        5004,
        5006,
        5088,
        5246,
        5249,
        5270,
        5273,
        5284,
        5726,
        5947,
        5962,
        5984,
        5993,
        6009,
        6016,
        6020,
        6022,
        6025,
        6027,
        6038,
        6040,
        6042,
        6157,
        6198,
        6253,
        6256,
        6298,
        6328,
        6342,
        6345,
        6368,
        6386,
        6467,
        6533,
        6662,
        6831,
        6876,
        6917,
        6948,
        7120,
        7207,
        7242,
        7251,
        7305,
        7306,
        7328,
        7329,
        7355,
        7425,
        7463,
        7536,
        7540,
        7591,
        7668,
        7671,
        7675,
        7681,
        7683,
        7726,
        7786,
        7796,
        7801,
        7834,
        7846,
        7857,
        7893,
        7940,
        7964,
        7973,
        7993,
        8005,
        8008,
        8013,
        8094,
        8153,
        8169,
        8171,
        8194,
        8240,
        8274,
        8351,
        8386,
        8395,
        8396,
        8407,
        8409,
        8425,
        8456,
        8458,
        8486,
        8489,
        8507,
        8544,
        8579,
        8584,
        8586,
        8597,
        8600,
        8615,
        8618,
        8620,
        8666,
        8690,
        8705,
        8711,
        8718,
        8742,
        8756,
        8896,
        8899,
        8948,
        9067
    ],
    "bravos": [
        22
    ],
    "bankon": [
        33
    ],
    "bo": [
        789,
        1046,
        33,
        244,
        960,
        1005,
        6017,
        6018,
        6019,
        3791,
        447,
        572,
        1084,
        1207,
        1342,
        1343,
        1346,
        1347,
        1348,
        1349,
        1351,
        1711,
        2259,
        2286,
        2721,
        2810,
        2868,
        3160,
        3267,
        3272,
        3413,
        4268,
        5116,
        5271,
        6079,
        6232,
        6316,
        6394,
        6404,
        6505,
        6673,
        7115,
        7615,
        7626,
        7712,
        7995,
        8936,
        8942
    ],
    "bon": [
        2676,
        33,
        1003
    ],
    "bukhara arabic": [
        39
    ],
    "bukhara": [
        39
    ],
    "buxara arabic": [
        39
    ],
    "buxara": [
        39
    ],
    "bea": [
        41,
        4645
    ],
    "beada": [
        41
    ],
    "biada": [
        41
    ],
    "bogijiab": [
        41
    ],
    "bojigiyab": [
        41
    ],
    "bojigniji": [
        41
    ],
    "bojigyab": [
        41
    ],
    "bakor": [
        43
    ],
    "befun": [
        43
    ],
    "bofon": [
        43
    ],
    "ba’ban": [
        45
    ],
    "bron": [
        49
    ],
    "brong": [
        49
    ],
    "bahasa ambon": [
        50
    ],
    "bahasa": [
        3700,
        7734,
        50,
        612,
        832,
        3074,
        3131,
        3132,
        3133,
        3322,
        3760,
        4486,
        4598,
        4637,
        5067,
        5068,
        5070,
        5081,
        6222,
        7735,
        8541,
        8542,
        9077,
        9078,
        6725
    ],
    "bahasa melaju ambon": [
        50
    ],
    "bahasa melayu ambon": [
        50
    ],
    "baharna": [
        55
    ],
    "baharna arabic": [
        55
    ],
    "baharnah": [
        55
    ],
    "bahraini arabic": [
        55
    ],
    "bahraini": [
        55
    ],
    "bahraini shi’ite arabic": [
        55
    ],
    "bahrani": [
        55
    ],
    "bahrani arabic": [
        55
    ],
    "bh": [
        55,
        408
    ],
    "bahrain": [
        55,
        408
    ],
    "barue": [
        59
    ],
    "bunta": [
        61
    ],
    "bahsa acèh": [
        63,
        64
    ],
    "bahsa": [
        63,
        64
    ],
    "basa acèh": [
        63,
        64
    ],
    "basa": [
        1319,
        7183,
        7185,
        7186,
        63,
        64,
        620,
        621,
        622,
        626,
        1050,
        1127,
        1177,
        1178,
        4167,
        4573,
        4582,
        4583,
        4584,
        4859,
        6350,
        6747,
        7184
    ],
    "balawa": [
        69
    ],
    "bale": [
        7013,
        69,
        4269,
        4784
    ],
    "balwa": [
        69
    ],
    "baghdadi": [
        70
    ],
    "badre": [
        90
    ],
    "bedere": [
        90
    ],
    "bedire": [
        90
    ],
    "bidire": [
        90
    ],
    "bɛdɩrɛ": [
        90
    ],
    "badama": [
        93
    ],
    "bengni-boga’er": [
        94,
        95
    ],
    "boga’er": [
        95,
        94
    ],
    "boga’er luoba": [
        94,
        95
    ],
    "bokar": [
        94,
        95
    ],
    "bori-karko": [
        94,
        95
    ],
    "bungni-bogar": [
        94,
        95
    ],
    "benbakanjamata": [
        104
    ],
    "binbarnja": [
        104
    ],
    "baco": [
        121
    ],
    "bata’o": [
        122
    ],
    "bedawi": [
        537,
        136,
        451,
        724,
        725,
        582
    ],
    "black seminole": [
        146
    ],
    "black": [
        146,
        598,
        648,
        921,
        933,
        934,
        935,
        1239,
        1329,
        1827,
        2986,
        2989,
        2991,
        3169,
        3170,
        4322,
        4620,
        5723,
        5893,
        6523,
        8684,
        8753,
        8805,
        8819,
        8883,
        8887,
        8916,
        8949,
        8950,
        9015
    ],
    "bare": [
        6502,
        153
    ],
    "bangalema": [
        157
    ],
    "bangelima": [
        157
    ],
    "bogen": [
        168
    ],
    "bogue": [
        168
    ],
    "buhi": [
        175,
        495,
        7898
    ],
    "bogo": [
        186,
        1284,
        1285
    ],
    "bibling": [
        198
    ],
    "barbuda": [
        200,
        2122
    ],
    "broken english": [
        200,
        6077
    ],
    "broken": [
        200,
        2754,
        6077,
        7371
    ],
    "burumakok": [
        211
    ],
    "barbari": [
        212
    ],
    "berberi": [
        212
    ],
    "benin": [
        463,
        464,
        847,
        221,
        1052,
        1777,
        514,
        574,
        633,
        722,
        925,
        939,
        1050,
        1357,
        1465,
        1943,
        2410,
        2413,
        2422,
        2482,
        2546,
        2558,
        2562,
        2823,
        3127,
        3137,
        3148,
        3174,
        3908,
        4857,
        5020,
        5216,
        5652,
        5653,
        5716,
        6152,
        7047,
        7265,
        7354,
        7437,
        8208,
        8375,
        8493,
        8693,
        8697,
        8871
    ],
    "bj": [
        221,
        514,
        574,
        633,
        722,
        925,
        939,
        1050,
        1052,
        1357,
        1465,
        1777,
        1943,
        2410,
        2413,
        2422,
        2482,
        2546,
        2558,
        2562,
        2823,
        3127,
        3137,
        3148,
        3174,
        3908,
        4857,
        5020,
        5216,
        5652,
        5653,
        5716,
        6152,
        7047,
        7265,
        7354,
        7437,
        8208,
        8375,
        8493,
        8693,
        8697,
        8871
    ],
    "batak angkola": [
        232,
        233
    ],
    "batak": [
        232,
        233,
        635,
        636,
        1147,
        1154,
        1160,
        1161,
        1166,
        1167,
        1169,
        1271
    ],
    "ba": [
        244,
        299,
        1037,
        1146,
        7608,
        1114,
        1115,
        3043,
        7089,
        7093
    ],
    "beta israel": [
        282,
        283,
        284
    ],
    "beta": [
        282,
        283,
        284
    ],
    "bakurut": [
        292
    ],
    "biltine": [
        294
    ],
    "bd": [
        296,
        362,
        969,
        970,
        1381,
        1384,
        1499,
        1661,
        1662,
        1663,
        2083,
        4534,
        4685,
        4837,
        4841,
        4842,
        5054,
        5055,
        6171,
        6172,
        6537,
        6762,
        6763,
        6764,
        7271,
        7272,
        7273,
        7633,
        7662,
        7663,
        8016,
        8017
    ],
    "bangladesh": [
        3224,
        2083,
        296,
        362,
        969,
        970,
        1381,
        1384,
        1499,
        1661,
        1662,
        1663,
        4534,
        4685,
        4837,
        4841,
        4842,
        5054,
        5055,
        6171,
        6172,
        6537,
        6762,
        6763,
        6764,
        7271,
        7272,
        7273,
        7633,
        7662,
        7663,
        8016,
        8017
    ],
    "businka": [
        329
    ],
    "bragat": [
        349
    ],
    "balif": [
        354
    ],
    "bambita arapesh": [
        359
    ],
    "bambita": [
        359
    ],
    "bumbita arapesh": [
        359
    ],
    "bumbita": [
        359
    ],
    "but arapesh": [
        359
    ],
    "but": [
        359,
        5929,
        5930
    ],
    "bukiyip": [
        371,
        372,
        373
    ],
    "bukiyúp": [
        371,
        372,
        373
    ],
    "bukiyip - coastal arapesh": [
        372
    ],
    "bukiyip - mountain arapesh": [
        373
    ],
    "bizaa": [
        381
    ],
    "biyáti": [
        391
    ],
    "biyáti’": [
        391
    ],
    "baler negrito": [
        400
    ],
    "baler": [
        400
    ],
    "bce": [
        435,
        436,
        437,
        438,
        5824
    ],
    "bintucua": [
        441
    ],
    "bintuk": [
        441
    ],
    "bintukwa": [
        441
    ],
    "bíntuka": [
        441
    ],
    "bíntukua": [
        441
    ],
    "bítuncua": [
        441
    ],
    "bolivia": [
        447,
        572,
        1084,
        1207,
        1342,
        1343,
        1346,
        1347,
        1348,
        1349,
        1351,
        1711,
        2259,
        2286,
        2721,
        2810,
        2868,
        3160,
        3267,
        3272,
        3413,
        4268,
        5116,
        5271,
        6079,
        6232,
        6316,
        6394,
        6404,
        6505,
        6673,
        7115,
        7615,
        7626,
        7712,
        7995,
        8936,
        8942
    ],
    "benin sign language": [
        463,
        464
    ],
    "burkina faso sign language": [
        463,
        464
    ],
    "burkina": [
        2487,
        463,
        464,
        2486,
        2488,
        6238,
        648,
        757,
        838,
        1005,
        1022,
        1231,
        1239,
        1246,
        1258,
        1530,
        1590,
        1816,
        1820,
        1827,
        1922,
        1946,
        2031,
        2040,
        2354,
        2366,
        2420,
        2704,
        2824,
        3619,
        3846,
        3904,
        3973,
        4162,
        4270,
        4441,
        4974,
        4975,
        5614,
        5713,
        5747,
        6233,
        6360,
        6536,
        6694,
        6787,
        6789,
        6790,
        6871,
        6926,
        6942,
        7042,
        7167,
        7274,
        7511,
        7742,
        7803,
        8084,
        8178,
        8228,
        8616
    ],
    "buruwai": [
        468
    ],
    "badzumbo": [
        477
    ],
    "bable": [
        478
    ],
    "boule": [
        493
    ],
    "bay": [
        4862,
        4885,
        6796,
        7151,
        8138,
        8591,
        2231,
        519,
        1608,
        1609,
        1612,
        1613,
        2315,
        3236,
        3957,
        4304,
        4367,
        4773,
        6115,
        7010,
        7573,
        8006
    ],
    "bolmac": [
        532
    ],
    "brignan": [
        535
    ],
    "brinya": [
        535
    ],
    "baiswari": [
        546
    ],
    "ba:tyana": [
        550
    ],
    "batjana": [
        550
    ],
    "bïde": [
        559
    ],
    "bulamu": [
        566
    ],
    "bulanja": [
        566
    ],
    "bulanu": [
        566
    ],
    "beiradão": [
        567
    ],
    "branco": [
        567
    ],
    "beka": [
        568,
        8365
    ],
    "beká": [
        568
    ],
    "bu": [
        3365,
        9001,
        1535,
        1536,
        3755,
        9015,
        9044,
        9045,
        569
    ],
    "borendy": [
        571
    ],
    "borindi": [
        571
    ],
    "badja": [
        576
    ],
    "baldya": [
        576
    ],
    "balfja": [
        576
    ],
    "bataan ayta": [
        588
    ],
    "bataan": [
        588
    ],
    "bataan sambal": [
        588
    ],
    "brat": [
        591
    ],
    "black phula": [
        598,
        8805,
        8819,
        8883,
        8916
    ],
    "basket": [
        598,
        8792,
        8819,
        8887
    ],
    "bajo": [
        6142,
        696,
        603,
        604,
        1548,
        1555,
        1656,
        1702,
        1710,
        4581,
        4798,
        5016,
        5264,
        5458,
        7360,
        7702,
        8118
    ],
    "buenaventura": [
        605
    ],
    "bambuluwe": [
        606
    ],
    "bashkort": [
        609
    ],
    "bashkir": [
        609
    ],
    "bashqort": [
        609
    ],
    "basquort": [
        609
    ],
    "babatana": [
        610
    ],
    "bainouk-gunyuño": [
        611
    ],
    "bagnoun": [
        611,
        684
    ],
    "bainounk-gujaher": [
        611
    ],
    "bainuk": [
        611,
        684
    ],
    "banhum": [
        611,
        684
    ],
    "banyuk": [
        611,
        684
    ],
    "banyum": [
        611,
        684
    ],
    "banyun": [
        611,
        684
    ],
    "banyung": [
        611,
        684
    ],
    "badui": [
        612
    ],
    "baduy": [
        612
    ],
    "bahasa sunda": [
        612
    ],
    "baré": [
        613
    ],
    "balé": [
        613
    ],
    "barauana": [
        613
    ],
    "barauna": [
        613
    ],
    "barawana": [
        613
    ],
    "baca": [
        614
    ],
    "bongo": [
        1018,
        614,
        1030,
        3315
    ],
    "bacenga": [
        615
    ],
    "baki": [
        892,
        615
    ],
    "batchenga": [
        615
    ],
    "betsinga": [
        615
    ],
    "betzinga": [
        615
    ],
    "bahamas english creole": [
        616
    ],
    "bahamas": [
        616,
        2131
    ],
    "bahamas creole english": [
        616
    ],
    "bahamian dialect": [
        616
    ],
    "bahamian": [
        616
    ],
    "bahamian english creole": [
        616
    ],
    "bs": [
        616,
        2131
    ],
    "barakai": [
        617
    ],
    "baluchi": [
        618,
        619,
        790,
        791,
        793
    ],
    "balochi, southern": [
        618,
        619
    ],
    "balochi": [
        790,
        791,
        793,
        618,
        619
    ],
    "baloci": [
        618,
        619,
        790,
        791,
        793
    ],
    "baluci": [
        618,
        619,
        790,
        791,
        793
    ],
    "balóchi": [
        619,
        618
    ],
    "bali": [
        620,
        621,
        622,
        672,
        674,
        647,
        3024,
        4776,
        7418,
        5138
    ],
    "balinese": [
        4781,
        620,
        621,
        622
    ],
    "basa bali": [
        620,
        621,
        622
    ],
    "barasano": [
        623,
        1129,
        6256
    ],
    "barasano del norte": [
        623
    ],
    "barazana": [
        623
    ],
    "bará-tuyuka": [
        623
    ],
    "bantawa": [
        624
    ],
    "bantaba": [
        624
    ],
    "bantawa dum": [
        624
    ],
    "bantawa rai": [
        624
    ],
    "bantawa yong": [
        624
    ],
    "bantawa yüng": [
        624
    ],
    "bontawa": [
        624
    ],
    "bavarian": [
        625
    ],
    "bairisch": [
        625
    ],
    "bavarian austrian": [
        625
    ],
    "bayerisch": [
        625
    ],
    "boarisch": [
        625
    ],
    "basaa": [
        626
    ],
    "basa (cameroon)": [
        626
    ],
    "bassa": [
        1132,
        1133,
        626,
        1319,
        5612
    ],
    "bicek": [
        626
    ],
    "bikyek": [
        626
    ],
    "bisaa": [
        626
    ],
    "bada (nigeria)": [
        627
    ],
    "bada": [
        835,
        627,
        4029
    ],
    "badanchi": [
        627
    ],
    "badawa": [
        627
    ],
    "bada’": [
        627
    ],
    "bat": [
        627
    ],
    "babungo": [
        628
    ],
    "bambili-bambui": [
        629
    ],
    "bambili": [
        629
    ],
    "bamun": [
        630,
        631
    ],
    "bamoum": [
        630,
        631
    ],
    "bamoun": [
        630,
        631
    ],
    "bamum": [
        630,
        631
    ],
    "batuley": [
        632
    ],
    "baatonum": [
        633
    ],
    "baatombu": [
        633
    ],
    "baatonu": [
        633
    ],
    "baatonun": [
        633
    ],
    "baatonun-kwara": [
        633
    ],
    "barba": [
        633
    ],
    "barganchi": [
        633
    ],
    "bargawa": [
        633
    ],
    "bargu": [
        633,
        1267
    ],
    "bariba": [
        633,
        1065,
        1188
    ],
    "baruba": [
        633
    ],
    "batonnum": [
        633
    ],
    "batonu": [
        633
    ],
    "berba": [
        633,
        722
    ],
    "bogung": [
        633
    ],
    "borgawa": [
        633
    ],
    "borgu": [
        2482,
        633,
        4655,
        4656
    ],
    "burgu": [
        633
    ],
    "barai": [
        634
    ],
    "batak toba": [
        635,
        636
    ],
    "batta": [
        635,
        636,
        1144,
        1154
    ],
    "bau": [
        6993,
        637,
        9146,
        9147,
        1281
    ],
    "bangba": [
        638,
        1397
    ],
    "baibai": [
        639
    ],
    "barama": [
        640
    ],
    "bavarama": [
        640
    ],
    "bugan": [
        641
    ],
    "bengan": [
        641
    ],
    "ben’gan yu": [
        641
    ],
    "ben’gan": [
        641
    ],
    "bogan": [
        641
    ],
    "bugeng": [
        641
    ],
    "barombi": [
        642
    ],
    "balombi": [
        642
    ],
    "barumbi": [
        642
    ],
    "baloum": [
        643
    ],
    "bamileke-bandjoun": [
        643
    ],
    "bandjoun": [
        643
    ],
    "banjoun-baham": [
        643
    ],
    "banjun": [
        643
    ],
    "batie": [
        643
    ],
    "babanki": [
        644
    ],
    "bats": [
        645
    ],
    "bac": [
        645
    ],
    "batsaw": [
        645
    ],
    "batsba": [
        645
    ],
    "batsbi": [
        645
    ],
    "batsbiitsy": [
        645
    ],
    "batsi": [
        7888,
        645
    ],
    "babango": [
        646
    ],
    "bango": [
        646
    ],
    "bwa": [
        1244,
        1171,
        646,
        674
    ],
    "bali-vitu": [
        647,
        8242
    ],
    "black bobo": [
        648,
        1239
    ],
    "bobo": [
        1239,
        960,
        1022,
        648
    ],
    "bobo da": [
        648
    ],
    "bobo fi": [
        648,
        1239
    ],
    "bobo madaré": [
        648
    ],
    "boboda": [
        648,
        1239
    ],
    "bf": [
        648,
        757,
        838,
        1005,
        1022,
        1231,
        1239,
        1246,
        1258,
        1530,
        1590,
        1816,
        1820,
        1827,
        1922,
        1946,
        2031,
        2040,
        2354,
        2366,
        2420,
        2487,
        2704,
        2824,
        3619,
        3846,
        3904,
        3973,
        4162,
        4270,
        4441,
        4974,
        4975,
        5614,
        5713,
        5747,
        6233,
        6238,
        6360,
        6536,
        6694,
        6787,
        6789,
        6790,
        6871,
        6926,
        6942,
        7042,
        7167,
        7274,
        7511,
        7742,
        7803,
        8084,
        8178,
        8228,
        8616
    ],
    "burkina faso": [
        648,
        757,
        838,
        1005,
        1022,
        1231,
        1239,
        1246,
        1258,
        1530,
        1590,
        1816,
        1820,
        1827,
        1922,
        1946,
        2031,
        2040,
        2354,
        2366,
        2420,
        2487,
        2704,
        2824,
        3619,
        3846,
        3904,
        3973,
        4162,
        4270,
        4441,
        4974,
        4975,
        5614,
        5713,
        5747,
        6233,
        6238,
        6360,
        6536,
        6694,
        6787,
        6789,
        6790,
        6871,
        6926,
        6942,
        7042,
        7167,
        7274,
        7511,
        7742,
        7803,
        8084,
        8178,
        8228,
        8616
    ],
    "banda, west central": [
        649
    ],
    "banda": [
        649,
        874,
        976,
        4431,
        7652,
        1040,
        754,
        1060,
        4331,
        4347,
        5418
    ],
    "bamali": [
        650
    ],
    "bagasin": [
        651
    ],
    "begasin": [
        651
    ],
    "begesin": [
        651
    ],
    "bakpinka": [
        652
    ],
    "begbungba": [
        652
    ],
    "barke": [
        653
    ],
    "barko": [
        653
    ],
    "burkunawa": [
        653
    ],
    "bakuli": [
        654
    ],
    "bakulu": [
        654
    ],
    "bakulung": [
        654
    ],
    "bambur": [
        654
    ],
    "baba": [
        4605,
        656,
        2723,
        6089
    ],
    "baba i": [
        656
    ],
    "bapa": [
        656
    ],
    "bapakum": [
        656
    ],
    "bubia": [
        657
    ],
    "bobe": [
        657,
        1197
    ],
    "bobea": [
        657
    ],
    "bota": [
        657
    ],
    "befang": [
        658
    ],
    "beba-befang": [
        658
    ],
    "biba-bifang": [
        658
    ],
    "bifang": [
        658
    ],
    "babalia creole arabic": [
        659
    ],
    "babalia": [
        659,
        1268
    ],
    "bai, central": [
        660,
        661
    ],
    "bai": [
        660,
        661,
        694,
        744,
        764,
        765,
        4215,
        1057,
        2003,
        2231,
        2655,
        3050,
        5197,
        5198,
        5199,
        5200,
        5201,
        7825,
        7826,
        8761,
        8913
    ],
    "báiyǔ": [
        660,
        661
    ],
    "bainouk-samik": [
        662
    ],
    "babar, north": [
        663
    ],
    "babar": [
        663,
        8065,
        5230
    ],
    "bamenyam": [
        664
    ],
    "bamenyan": [
        664
    ],
    "bamu": [
        665
    ],
    "bamu owera": [
        665
    ],
    "bamu kiwai": [
        665
    ],
    "baga pokur": [
        666
    ],
    "baga": [
        666,
        792,
        947,
        1054,
        1055,
        1131,
        1139,
        1140,
        4620
    ],
    "baga binari": [
        666
    ],
    "binari": [
        666
    ],
    "baga mboteni": [
        666
    ],
    "baga poukour": [
        666
    ],
    "baga de binari": [
        666
    ],
    "baka": [
        692,
        887,
        666,
        792,
        947,
        1131,
        1139,
        1140,
        7959,
        7960
    ],
    "barka": [
        666,
        947,
        1139,
        1140
    ],
    "binari-kouffin": [
        666
    ],
    "bohere": [
        666
    ],
    "bariai": [
        667
    ],
    "baoulé": [
        668
    ],
    "baoule": [
        668
    ],
    "baule": [
        668
    ],
    "baule-ando": [
        668
    ],
    "bawule": [
        668
    ],
    "bardi": [
        669
    ],
    "baadi": [
        669
    ],
    "baardi": [
        669
    ],
    "badi": [
        669
    ],
    "bard": [
        669
    ],
    "bunuba": [
        670
    ],
    "booneba": [
        670
    ],
    "bunaba": [
        670
    ],
    "bunapa": [
        670
    ],
    "bannoni": [
        671
    ],
    "banoni": [
        671
    ],
    "bali (nigeria)": [
        672
    ],
    "bibaali": [
        672
    ],
    "bosavi": [
        673
    ],
    "baali": [
        674
    ],
    "bali (democratic republic of congo)": [
        674
    ],
    "bench": [
        675,
        676
    ],
    "benc’non": [
        676
    ],
    "babine": [
        677
    ],
    "babine carrier": [
        677
    ],
    "bahumono": [
        678
    ],
    "bhahumono": [
        678
    ],
    "bendi": [
        679,
        4208
    ],
    "bing": [
        680
    ],
    "biliau": [
        680
    ],
    "bakula": [
        681,
        1427,
        3422,
        4259
    ],
    "bana": [
        682,
        701,
        5664
    ],
    "bàná": [
        682
    ],
    "baza": [
        682,
        4029,
        5422
    ],
    "bacama": [
        683
    ],
    "bacama-bwatiye": [
        683
    ],
    "bachama": [
        683
    ],
    "bashama": [
        683
    ],
    "bashamma": [
        683
    ],
    "besema": [
        683
    ],
    "bwaatye": [
        683,
        1144
    ],
    "bwareba": [
        683
    ],
    "bwatiye": [
        683,
        1144
    ],
    "bainouk-gunyaamolo": [
        684
    ],
    "bayot": [
        685
    ],
    "baiot": [
        685
    ],
    "baiote": [
        685
    ],
    "bayote": [
        685
    ],
    "bayotte": [
        685
    ],
    "basap": [
        686,
        6890
    ],
    "bosap": [
        686
    ],
    "baudó": [
        687
    ],
    "bunama": [
        688
    ],
    "bade": [
        689,
        1760
    ],
    "badanci": [
        689
    ],
    "bedde": [
        689
    ],
    "bede": [
        689
    ],
    "biage": [
        690
    ],
    "bonggi": [
        691
    ],
    "bangay": [
        691
    ],
    "baká e": [
        692
    ],
    "baká": [
        692
    ],
    "baka (south sudan)": [
        692
    ],
    "baaka": [
        8365,
        692
    ],
    "burun": [
        693,
        4735
    ],
    "borun": [
        693,
        3914
    ],
    "bai (south sudan)": [
        694
    ],
    "bari": [
        741,
        742,
        694,
        3572,
        5581,
        3999
    ],
    "budukh": [
        695
    ],
    "budug": [
        695
    ],
    "budugi": [
        695
    ],
    "buduk": [
        695
    ],
    "budux": [
        695
    ],
    "bukukhi": [
        695
    ],
    "bajau, indonesian": [
        696
    ],
    "bajau": [
        696,
        702,
        1953,
        6896,
        6972,
        7129,
        7132,
        7133
    ],
    "badjaw": [
        696,
        6972
    ],
    "badjo": [
        696
    ],
    "bajao": [
        696,
        702
    ],
    "bayo": [
        696,
        2685
    ],
    "baʔong sama": [
        696
    ],
    "baʔong": [
        696
    ],
    "bajaw": [
        696,
        702
    ],
    "buduma": [
        697
    ],
    "boudouma": [
        697
    ],
    "baldemu": [
        698
    ],
    "baldamu": [
        698
    ],
    "baldare": [
        698
    ],
    "bernde": [
        699
    ],
    "bende": [
        700,
        3130
    ],
    "babende": [
        700
    ],
    "bhabhēnde": [
        700
    ],
    "bahnar": [
        701,
        3051
    ],
    "bajau, west coast": [
        702
    ],
    "bajau sama": [
        702
    ],
    "burunge": [
        703
    ],
    "burungaisoo": [
        703
    ],
    "bulunge": [
        703
    ],
    "burunga iso": [
        703
    ],
    "burunga": [
        703
    ],
    "burungee": [
        703
    ],
    "burungi": [
        703
    ],
    "bhogoto": [
        704
    ],
    "bhokoto": [
        704
    ],
    "bogodo": [
        704
    ],
    "bogoto": [
        704
    ],
    "bokodo": [
        704
    ],
    "bokoto": [
        704
    ],
    "bokpoto": [
        704
    ],
    "bakundu-balue": [
        705
    ],
    "bodo parja": [
        706
    ],
    "bodo": [
        706,
        1023,
        2548,
        1109,
        1110,
        1111,
        1190,
        2759,
        5288
    ],
    "bodo paraja": [
        706
    ],
    "baham": [
        707
    ],
    "budong-budong": [
        708
    ],
    "bubudong": [
        708
    ],
    "budo-budo": [
        708
    ],
    "bandjalang": [
        709
    ],
    "bandjelang": [
        709
    ],
    "bogganger": [
        709
    ],
    "bundala": [
        709
    ],
    "bundjalung": [
        709
    ],
    "badeshi": [
        710
    ],
    "badakhshi": [
        710,
        6299
    ],
    "belarusian": [
        711,
        712,
        713
    ],
    "belarusan": [
        711,
        712,
        713
    ],
    "belorussian": [
        711,
        712,
        713
    ],
    "bielorussian": [
        711,
        712,
        713
    ],
    "byelorussian": [
        711,
        712,
        713
    ],
    "by": [
        711,
        712,
        713,
        6551,
        6611
    ],
    "belarus": [
        711,
        712,
        713,
        6551,
        6611
    ],
    "beaver": [
        714,
        715
    ],
    "bebele": [
        716
    ],
    "bamvele": [
        716
    ],
    "bedoanas": [
        718
    ],
    "byangsi": [
        719
    ],
    "bhotia": [
        719,
        766,
        767,
        768,
        997,
        999,
        1000,
        1001,
        2044,
        3339,
        3986,
        4222,
        4223,
        3651,
        6303,
        6304,
        6879,
        8640
    ],
    "byangkho lwo": [
        719
    ],
    "byangkho": [
        719
    ],
    "byangkhopa": [
        719
    ],
    "byanshi": [
        719
    ],
    "byansi": [
        719
    ],
    "byasi": [
        719
    ],
    "benabena": [
        720
    ],
    "bena": [
        740,
        8934,
        720,
        8132
    ],
    "belait": [
        721
    ],
    "balait jati": [
        721
    ],
    "balait": [
        721
    ],
    "bn": [
        721,
        1117,
        4102,
        4103,
        5069,
        7761,
        9019
    ],
    "brunei darussalam": [
        721,
        1117,
        4102,
        4103,
        5069,
        7761,
        9019
    ],
    "brunei": [
        4102,
        4103,
        1117,
        721,
        5069,
        7761,
        9019
    ],
    "biali": [
        722
    ],
    "byali": [
        722
    ],
    "bialaba": [
        722
    ],
    "bieri": [
        722,
        1088
    ],
    "bjerb": [
        722
    ],
    "bjeri": [
        722
    ],
    "burba": [
        722
    ],
    "bakati’": [
        723,
        4474,
        7105
    ],
    "bakati nyam": [
        723
    ],
    "bakati": [
        723,
        4474
    ],
    "bakati riok": [
        723
    ],
    "bakatik dayak": [
        723
    ],
    "bakatik": [
        723
    ],
    "bakatiq": [
        723
    ],
    "bekati": [
        723
    ],
    "bekati'": [
        723
    ],
    "bedawiyet": [
        724,
        725
    ],
    "bedawiye": [
        724,
        725
    ],
    "bedawye": [
        724,
        725
    ],
    "bedja": [
        724,
        725
    ],
    "bedwi": [
        724,
        725
    ],
    "bedya": [
        724,
        725
    ],
    "bedàwie": [
        724,
        725
    ],
    "beja": [
        724,
        725
    ],
    "beḍauye": [
        724,
        725
    ],
    "bidhaaweet": [
        724,
        725
    ],
    "bidhaawyeet": [
        725,
        724
    ],
    "biďaːwyéːt": [
        724,
        725
    ],
    "bedawiat": [
        724,
        725
    ],
    "bedawie": [
        724,
        725
    ],
    "bdhaawi": [
        724,
        725
    ],
    "bebeli": [
        726
    ],
    "banaule": [
        726
    ],
    "beli": [
        739,
        923,
        726
    ],
    "benaule": [
        726
    ],
    "bemba": [
        727,
        728
    ],
    "bemba (zambia)": [
        727,
        728
    ],
    "bedamuni": [
        729
    ],
    "beami": [
        729
    ],
    "bedamini": [
        729
    ],
    "biami": [
        729,
        6154
    ],
    "behoa": [
        730
    ],
    "besoa": [
        730
    ],
    "básá behóá": [
        730
    ],
    "básá": [
        730
    ],
    "behóá": [
        730
    ],
    "beembe": [
        731,
        945
    ],
    "bembe": [
        945,
        731
    ],
    "besme": [
        732
    ],
    "beseme": [
        732
    ],
    "besemme": [
        732
    ],
    "bodor": [
        732
    ],
    "bété, guiberoua": [
        733
    ],
    "bété": [
        733,
        735,
        1150
    ],
    "béte": [
        733
    ],
    "blagar": [
        734
    ],
    "belagar": [
        734
    ],
    "bété, daloa": [
        735
    ],
    "betawi": [
        736
    ],
    "batavi": [
        736
    ],
    "batavian": [
        736
    ],
    "batawi": [
        736
    ],
    "betawi malay": [
        736
    ],
    "beli (papua new guinea)": [
        739
    ],
    "bena (tanzania)": [
        740
    ],
    "bareli, pauri": [
        743
    ],
    "bareli": [
        743,
        782,
        1047
    ],
    "barewali": [
        743
    ],
    "barli": [
        743
    ],
    "bai, panyi": [
        744
    ],
    "bijiang bai": [
        744
    ],
    "bijiang": [
        744
    ],
    "bafut": [
        745
    ],
    "bɨfɨɨ̀": [
        745
    ],
    "befe": [
        745
    ],
    "bufe": [
        745
    ],
    "betaf": [
        746
    ],
    "bofi": [
        747
    ],
    "boffi": [
        747
    ],
    "busang": [
        748
    ],
    "busaang": [
        748
    ],
    "busang kayan": [
        748
    ],
    "blafe": [
        749
    ],
    "blafe wonana": [
        749
    ],
    "british sign language": [
        750,
        751
    ],
    "british": [
        750,
        751,
        2153,
        2166,
        2220
    ],
    "bsl": [
        750,
        751,
        8906
    ],
    "bafanji": [
        752
    ],
    "bafangi": [
        752
    ],
    "bafanyi": [
        752
    ],
    "ban khor sign language": [
        753
    ],
    "ban": [
        753,
        3283,
        3284,
        3285,
        3286,
        3287,
        3406,
        6530,
        8186,
        8804,
        8898
    ],
    "bksl": [
        753
    ],
    "banda-ndélé": [
        754
    ],
    "banda of ndélé": [
        754
    ],
    "bafmen": [
        755
    ],
    "bafmeng": [
        755
    ],
    "bafoumeng": [
        755
    ],
    "bafumen": [
        755
    ],
    "bunak": [
        756
    ],
    "buna": [
        1209,
        756,
        4654,
        5531,
        8132,
        8934
    ],
    "bunake": [
        756
    ],
    "bunaq": [
        756
    ],
    "buna’": [
        756
    ],
    "birifor, malba": [
        757
    ],
    "birifor": [
        757,
        854
    ],
    "birafour": [
        757
    ],
    "birifo": [
        757,
        854
    ],
    "bɩrfʋɔr": [
        757
    ],
    "beba": [
        758
    ],
    "babadji": [
        758
    ],
    "baba’zhi": [
        758
    ],
    "batadji": [
        758
    ],
    "bazhi": [
        758
    ],
    "bebadji": [
        758
    ],
    "beba’": [
        758
    ],
    "biba": [
        758
    ],
    "bombe": [
        758
    ],
    "bombe-beba": [
        758
    ],
    "badaga": [
        759,
        760,
        761,
        762
    ],
    "badag": [
        759,
        760,
        761,
        762
    ],
    "badagu": [
        759,
        760,
        761,
        762
    ],
    "baduga": [
        759,
        760,
        761,
        762
    ],
    "badugu": [
        759,
        760,
        761,
        762
    ],
    "bazigar": [
        763
    ],
    "bai, southern": [
        764,
        765
    ],
    "balti": [
        766,
        767,
        768
    ],
    "baltistani": [
        766,
        767,
        768
    ],
    "bhoti of baltistan": [
        766,
        767,
        768
    ],
    "bhoti": [
        5405,
        6711,
        6712,
        7064,
        766,
        767,
        768
    ],
    "baltistan": [
        766,
        767,
        768
    ],
    "bhotia of baltistan": [
        766,
        767,
        768
    ],
    "byltae": [
        766,
        767,
        768
    ],
    "boonan": [
        769,
        770
    ],
    "bunan": [
        769,
        770,
        985
    ],
    "boli": [
        3712,
        769,
        770,
        773,
        1837,
        2404,
        3616,
        3617,
        4192,
        4193,
        5190,
        6475,
        6530,
        8045
    ],
    "bondo": [
        771
    ],
    "bhonda bhasha": [
        771
    ],
    "bhonda": [
        771
    ],
    "bhasha": [
        1077,
        771,
        4834,
        6347,
        6650,
        6651,
        6652,
        6653,
        6654,
        6655,
        6656,
        6657,
        8670,
        8671,
        8672,
        8778
    ],
    "bonda": [
        771,
        7248
    ],
    "bondo-poraja": [
        771
    ],
    "bantayanon": [
        772
    ],
    "bagheli": [
        773
    ],
    "bagelkhandi": [
        773
    ],
    "bhugelkhud": [
        773
    ],
    "bulgarian": [
        775,
        776,
        777,
        778,
        1063,
        1677,
        1678,
        1679
    ],
    "bg": [
        775,
        776,
        777,
        778,
        1063,
        1679,
        6554,
        6590,
        7698
    ],
    "bulgaria": [
        775,
        776,
        777,
        778,
        1063,
        1679,
        6554,
        6590,
        7698
    ],
    "banganci": [
        779
    ],
    "bangawa": [
        779
    ],
    "bobongko": [
        780
    ],
    "bangaru": [
        781
    ],
    "banger": [
        781
    ],
    "bangri": [
        781
    ],
    "bangru": [
        781
    ],
    "bareli, rathwi": [
        782
    ],
    "barel": [
        782
    ],
    "barela": [
        782
    ],
    "bauria": [
        783
    ],
    "babri": [
        783
    ],
    "badak": [
        783
    ],
    "baori": [
        783
    ],
    "basria": [
        783
    ],
    "bawari": [
        783
    ],
    "bawaria": [
        783
    ],
    "bhoria": [
        783
    ],
    "bangandu": [
        784
    ],
    "bagando": [
        784
    ],
    "bangando": [
        784
    ],
    "bangantu": [
        784
    ],
    "bugun": [
        785
    ],
    "bagobo-klata": [
        786
    ],
    "bagobo": [
        796,
        786,
        5830
    ],
    "bagobo-guiangga": [
        786
    ],
    "bangolan": [
        787
    ],
    "bit": [
        788
    ],
    "boxing": [
        788
    ],
    "buxing": [
        788
    ],
    "buxing khmu": [
        788
    ],
    "buxinhua": [
        788
    ],
    "bet": [
        6825,
        788
    ],
    "bo (laos)": [
        789
    ],
    "boe": [
        789,
        1017
    ],
    "bor": [
        1249,
        789
    ],
    "balochi, western": [
        790,
        791
    ],
    "baga koga": [
        792
    ],
    "balochi, eastern": [
        793
    ],
    "bagri": [
        794,
        2574
    ],
    "bagari": [
        794
    ],
    "bagria": [
        794
    ],
    "bagris": [
        794
    ],
    "bahgri": [
        794
    ],
    "baorias": [
        794
    ],
    "bawri": [
        794
    ],
    "bawm": [
        795
    ],
    "bawm chin": [
        795
    ],
    "bawm hawlh": [
        795
    ],
    "bawn": [
        795
    ],
    "bawng": [
        795
    ],
    "boam": [
        795
    ],
    "bom": [
        795,
        949,
        965,
        1009
    ],
    "bughotu": [
        797
    ],
    "bugota": [
        797
    ],
    "bugoto": [
        797
    ],
    "bugotu": [
        797
    ],
    "bungnu": [
        798
    ],
    "bungun": [
        798
    ],
    "bunu": [
        1179,
        1235,
        1245,
        6244,
        798
    ],
    "bipim": [
        799
    ],
    "bipim as-so": [
        799
    ],
    "bhatri": [
        800
    ],
    "basturia": [
        800
    ],
    "bhatra": [
        800
    ],
    "bhattra": [
        800
    ],
    "bhattri": [
        800
    ],
    "bhottada": [
        800
    ],
    "bhottara": [
        800
    ],
    "balkan gagauz turkish": [
        801,
        802
    ],
    "balkan": [
        801,
        802,
        6553,
        6554,
        6555
    ],
    "balkan turkic": [
        801,
        802
    ],
    "benggoi": [
        803
    ],
    "bengoi": [
        803
    ],
    "banggai": [
        804
    ],
    "banggaai": [
        804
    ],
    "banggaiy": [
        804
    ],
    "banggay": [
        804
    ],
    "banggaya": [
        804
    ],
    "bharia": [
        805
    ],
    "bhar": [
        805
    ],
    "bharat": [
        805
    ],
    "bhumia": [
        805
    ],
    "bhumiya": [
        805
    ],
    "bhili": [
        806,
        807,
        817,
        8189,
        3655
    ],
    "bhagoria": [
        806,
        807
    ],
    "bhil": [
        2001,
        2002,
        6704,
        806,
        807,
        1393,
        1837,
        3655,
        4850,
        8059,
        8060,
        8189
    ],
    "bhilbari": [
        806,
        807
    ],
    "bhilboli": [
        806,
        807
    ],
    "bhilla": [
        806,
        807
    ],
    "bhilodi": [
        806,
        807,
        8189
    ],
    "biga": [
        808,
        7025
    ],
    "bhadrawahi": [
        809,
        810
    ],
    "baderwali": [
        809,
        810
    ],
    "badrohi": [
        809,
        810
    ],
    "bahi": [
        809,
        810
    ],
    "bhadarwahi": [
        809,
        810
    ],
    "bhaderbhai jamu": [
        809,
        810
    ],
    "bhaderbhai": [
        809,
        810
    ],
    "bhaderwali pahari": [
        809,
        810
    ],
    "bhaderwali": [
        809,
        810
    ],
    "bhadrava": [
        809,
        810
    ],
    "bhadri": [
        809,
        810
    ],
    "bhaya": [
        811
    ],
    "busa": [
        812,
        1065
    ],
    "busan": [
        812
    ],
    "binandere": [
        813
    ],
    "bukharic": [
        814,
        815,
        816
    ],
    "bokharan": [
        814,
        815,
        816
    ],
    "bokharian": [
        814,
        815,
        816
    ],
    "bokharic": [
        814,
        815,
        816
    ],
    "bukharan": [
        814,
        815,
        816
    ],
    "bukharian": [
        814,
        815,
        816
    ],
    "bukharin": [
        814,
        815,
        816
    ],
    "bhilali": [
        817
    ],
    "bhilala": [
        817
    ],
    "bahing": [
        818
    ],
    "baying": [
        818
    ],
    "bayung": [
        818
    ],
    "bimin": [
        819
    ],
    "bathari": [
        820
    ],
    "batahari": [
        820
    ],
    "bathara": [
        820
    ],
    "bautahari": [
        820
    ],
    "botahari": [
        820
    ],
    "bohtan neo-aramaic": [
        821
    ],
    "bohtan": [
        821
    ],
    "bhojpuri": [
        822,
        823,
        3013
    ],
    "bajpuri": [
        822,
        823
    ],
    "bhojapuri": [
        822,
        823
    ],
    "bhozpuri": [
        822,
        823
    ],
    "bima": [
        824
    ],
    "bimanese": [
        824
    ],
    "besi": [
        825,
        3647,
        4754,
        6320
    ],
    "buton": [
        825,
        1462,
        1463,
        1464,
        3647,
        8263
    ],
    "bara": [
        826,
        1109,
        1110,
        1111,
        2635,
        6256,
        6392
    ],
    "bara malagasy": [
        826
    ],
    "buwal": [
        827
    ],
    "bual": [
        827,
        917
    ],
    "bhattiyali": [
        828,
        829
    ],
    "bhateali": [
        828,
        829
    ],
    "bhatiali pahari": [
        828,
        829
    ],
    "bhatiali": [
        828,
        829
    ],
    "bhatiyali": [
        828,
        829
    ],
    "bhunjia": [
        830
    ],
    "bhumjiya": [
        830
    ],
    "bhunjiya": [
        830
    ],
    "bunjia": [
        830
    ],
    "bahau": [
        831
    ],
    "biak": [
        832
    ],
    "bahasa biak": [
        832
    ],
    "biak-numfor": [
        832
    ],
    "bhalay": [
        833
    ],
    "bhele": [
        834
    ],
    "bili": [
        834,
        845
    ],
    "bada (indonesia)": [
        835
    ],
    "bádá’": [
        835
    ],
    "bislama": [
        836
    ],
    "bichelamar": [
        836
    ],
    "badimaya": [
        837
    ],
    "bisa": [
        838,
        6548
    ],
    "bɩsa": [
        838
    ],
    "bissa": [
        838
    ],
    "bissa-barka": [
        838
    ],
    "boussanse": [
        838
    ],
    "busansi": [
        838
    ],
    "bidiyo": [
        839
    ],
    "bidio": [
        839
    ],
    "bidiya": [
        839
    ],
    "bidiyo-waana": [
        839
    ],
    "bidyo": [
        839
    ],
    "bepour": [
        840
    ],
    "biafada": [
        841
    ],
    "beafada": [
        841
    ],
    "bedfola": [
        841
    ],
    "biafar": [
        841
    ],
    "bidyola": [
        841
    ],
    "biangai": [
        842
    ],
    "bikol": [
        843,
        844,
        924,
        1156,
        1670,
        2349,
        4227,
        6488,
        7898,
        7121
    ],
    "bicol": [
        843,
        844,
        2349
    ],
    "bicol-naga": [
        843,
        844
    ],
    "bicolano": [
        843,
        844,
        902,
        1156,
        1670
    ],
    "bikol naga": [
        843,
        844
    ],
    "bikol, central": [
        843,
        844
    ],
    "bikolano": [
        843,
        844,
        924
    ],
    "bikolnon": [
        843,
        844
    ],
    "bille": [
        845
    ],
    "bile": [
        845
    ],
    "billanchi": [
        845
    ],
    "bimoba": [
        846
    ],
    "bini": [
        847,
        6150
    ],
    "biaka": [
        848,
        8365
    ],
    "bila": [
        849
    ],
    "bira": [
        1083,
        849
    ],
    "bipi": [
        850
    ],
    "bisorio": [
        851
    ],
    "berinomo": [
        852
    ],
    "bitara": [
        852
    ],
    "biate": [
        853
    ],
    "baite": [
        853
    ],
    "bedesa": [
        853
    ],
    "beite": [
        853
    ],
    "bete": [
        1276,
        853,
        1144
    ],
    "beteh": [
        853
    ],
    "biete": [
        853
    ],
    "birifor, southern": [
        854
    ],
    "birfoɔr": [
        854
    ],
    "berfoɔr": [
        854
    ],
    "bɩ rfʊ ɔ r": [
        854
    ],
    "bɩ": [
        854
    ],
    "bekol": [
        855
    ],
    "bikele": [
        855
    ],
    "bikele-bikay": [
        855
    ],
    "bikele-bikeng": [
        855
    ],
    "bokol": [
        855
    ],
    "bòkól": [
        855
    ],
    "bijori": [
        856
    ],
    "binjhia": [
        856
    ],
    "birijia": [
        856
    ],
    "birjia": [
        856
    ],
    "brijia": [
        856
    ],
    "burja": [
        856
    ],
    "birhor": [
        857,
        8487
    ],
    "bihor": [
        857
    ],
    "birhar": [
        857
    ],
    "birhore": [
        857
    ],
    "birhul": [
        857
    ],
    "baloi": [
        858
    ],
    "baato baloi": [
        858
    ],
    "baato": [
        858
    ],
    "boloi": [
        858
    ],
    "budza": [
        859
    ],
    "budja": [
        859
    ],
    "buja": [
        859
    ],
    "barngarla": [
        860
    ],
    "bahanga-la": [
        860
    ],
    "bangala": [
        1254,
        860,
        969,
        970,
        972,
        4406,
        4407,
        4408,
        5211
    ],
    "banggala": [
        860
    ],
    "banggarla": [
        860
    ],
    "bungeha": [
        860
    ],
    "bungela": [
        860
    ],
    "bariji": [
        861
    ],
    "bereho": [
        861
    ],
    "biao-jiao mien": [
        862
    ],
    "biao-jiao": [
        862
    ],
    "biao": [
        963,
        1281,
        862,
        4208
    ],
    "biao chao": [
        862
    ],
    "biaomin": [
        862
    ],
    "byau min": [
        862
    ],
    "byau": [
        862
    ],
    "barzani-sandu jewish neo-aramaic": [
        863
    ],
    "barzani-sandu": [
        863
    ],
    "barzani jewish neo-aramaic": [
        863
    ],
    "barzani": [
        863
    ],
    "bidyogo": [
        864
    ],
    "bijago": [
        864
    ],
    "bijogo": [
        864
    ],
    "bijougot": [
        864
    ],
    "bijuga": [
        864
    ],
    "budjago": [
        864
    ],
    "bugago": [
        864
    ],
    "bahinemo": [
        865
    ],
    "bahenemo": [
        865
    ],
    "burji": [
        866,
        867
    ],
    "bhakha": [
        868,
        1077
    ],
    "braj": [
        1077,
        868
    ],
    "braj kanauji": [
        868
    ],
    "barok": [
        869
    ],
    "bulu": [
        870,
        1183,
        6291,
        7269
    ],
    "bulu (papua new guinea)": [
        870
    ],
    "bajelani": [
        871
    ],
    "bajalani": [
        871
    ],
    "bajoran": [
        871
    ],
    "bejwan": [
        871
    ],
    "banjar": [
        872,
        873
    ],
    "bandjarese": [
        872,
        873
    ],
    "banjar malay": [
        872,
        873
    ],
    "banjar melau": [
        872,
        873
    ],
    "banjarese": [
        872,
        873
    ],
    "benjar": [
        872,
        873
    ],
    "banda, mid-southern": [
        874
    ],
    "banda central sud": [
        874
    ],
    "binumarien": [
        876
    ],
    "binamarir": [
        876
    ],
    "binumaria": [
        876
    ],
    "bajan": [
        877
    ],
    "barbadian creole english": [
        877
    ],
    "barbadian": [
        877
    ],
    "bb": [
        877,
        2127
    ],
    "barbados": [
        7964,
        877,
        2127
    ],
    "balanta-ganja": [
        878,
        879
    ],
    "balanda": [
        878,
        879,
        916
    ],
    "balant": [
        878,
        879,
        916
    ],
    "balante": [
        878,
        879,
        916
    ],
    "ballante": [
        878,
        879,
        916
    ],
    "belante": [
        878,
        879,
        916
    ],
    "brassa": [
        878,
        879,
        916
    ],
    "bulanda": [
        878,
        879,
        916
    ],
    "busuu": [
        880
    ],
    "bedjond": [
        881
    ],
    "bediondo": [
        881
    ],
    "bediondo mbai": [
        881
    ],
    "bedjondo": [
        881
    ],
    "bédjonde": [
        881
    ],
    "bejondo": [
        881
    ],
    "bakwé": [
        882
    ],
    "banao": [
        883
    ],
    "banao itneg": [
        883
    ],
    "banaw": [
        883
    ],
    "bhanaw tinggian": [
        883
    ],
    "bhanaw": [
        883
    ],
    "bayali": [
        884
    ],
    "baiali": [
        884
    ],
    "bajali": [
        884
    ],
    "bieli": [
        884
    ],
    "biyali": [
        884
    ],
    "byellee": [
        884
    ],
    "baruga": [
        885
    ],
    "bambuka": [
        886
    ],
    "baka (cameroon)": [
        887
    ],
    "bayaka": [
        887
    ],
    "bebayaga": [
        887
    ],
    "bebayaka": [
        887
    ],
    "bibaya": [
        887
    ],
    "binukid": [
        888
    ],
    "binokid": [
        888
    ],
    "binukid manobo": [
        888
    ],
    "bukidnon": [
        4601,
        888,
        5123,
        7107
    ],
    "beeke": [
        889
    ],
    "beke": [
        889,
        1730,
        8738
    ],
    "buraka": [
        890
    ],
    "bolaka": [
        890
    ],
    "boraka": [
        890
    ],
    "bouraka": [
        890
    ],
    "bakoko": [
        891
    ],
    "basoo": [
        891
    ],
    "burumba": [
        892
    ],
    "brokskat": [
        894
    ],
    "brok-skad": [
        894
    ],
    "brokpa": [
        894,
        6728,
        6823
    ],
    "brokpa of dah-hanu": [
        894
    ],
    "berik": [
        895
    ],
    "berick": [
        895
    ],
    "berrik": [
        895
    ],
    "bamekon": [
        896
    ],
    "bikom": [
        896
    ],
    "bukitan": [
        897
    ],
    "bakatan": [
        897
    ],
    "bakitan": [
        897
    ],
    "beketan": [
        897
    ],
    "bakoa": [
        898
    ],
    "bakwa": [
        898
    ],
    "bamileke-kwa": [
        898
    ],
    "boko": [
        899,
        1052,
        8314
    ],
    "boko (democratic republic of congo)": [
        899
    ],
    "bakairí": [
        900
    ],
    "bacairí": [
        900
    ],
    "bakumpai": [
        901
    ],
    "bara-jida": [
        901
    ],
    "boloki": [
        903
    ],
    "baloki": [
        903
    ],
    "boleki": [
        903
    ],
    "buluki": [
        903
    ],
    "buhid": [
        904,
        905
    ],
    "bangon": [
        981,
        904,
        905
    ],
    "batangan": [
        904,
        905,
        981,
        7819
    ],
    "buhid-mangyan": [
        904,
        905
    ],
    "bukil": [
        904,
        905
    ],
    "bekwarra": [
        906
    ],
    "bekwara": [
        906
    ],
    "bekworra": [
        906
    ],
    "bekwel": [
        907
    ],
    "bakwele": [
        907,
        1087
    ],
    "bakwil": [
        907
    ],
    "bekwie": [
        907
    ],
    "bekwil": [
        907
    ],
    "bɛkwyel": [
        907
    ],
    "baikeno": [
        908
    ],
    "baikenu": [
        908
    ],
    "biqueno": [
        908
    ],
    "bokyi": [
        909
    ],
    "boki": [
        909
    ],
    "byoki": [
        909
    ],
    "bungku": [
        910
    ],
    "blackfoot": [
        911,
        912
    ],
    "blackfeet": [
        911,
        912
    ],
    "bilua": [
        913
    ],
    "bella coola": [
        914
    ],
    "bella": [
        914
    ],
    "bolango": [
        915
    ],
    "bolaang uki": [
        915
    ],
    "bolaang": [
        915,
        4964
    ],
    "bolang-banka": [
        915
    ],
    "bulanga": [
        915
    ],
    "bulanga-uki": [
        915
    ],
    "balanta-kentohe": [
        916
    ],
    "balanta": [
        916,
        940
    ],
    "buol": [
        917
    ],
    "bwool": [
        917
    ],
    "bwo’ol": [
        917
    ],
    "belle": [
        918
    ],
    "belleh": [
        918
    ],
    "bolia": [
        919
    ],
    "bokoki": [
        919
    ],
    "bulia": [
        919
    ],
    "bulungan": [
        920
    ],
    "bolongan": [
        920
    ],
    "black karen": [
        921,
        6523
    ],
    "biloxi": [
        922
    ],
    "behli": [
        923
    ],
    "beili": [
        923
    ],
    "beli (south sudan)": [
        923
    ],
    "bikol, southern catanduanes": [
        924
    ],
    "baseca": [
        925
    ],
    "basila": [
        925
    ],
    "bassila": [
        925
    ],
    "blablanga": [
        926
    ],
    "blanga": [
        926
    ],
    "baluan-pam": [
        927
    ],
    "blang": [
        928,
        929,
        930,
        931,
        8032
    ],
    "bulang": [
        928,
        929,
        930,
        931,
        3909
    ],
    "bulang yu": [
        928,
        929,
        930,
        931
    ],
    "balaesang": [
        932
    ],
    "balaesan": [
        932
    ],
    "balaisang": [
        932
    ],
    "black tai": [
        933,
        934,
        935
    ],
    "bolo": [
        936
    ],
    "balangao": [
        937
    ],
    "balangao bontoc": [
        937
    ],
    "bontoc": [
        975,
        5827,
        6487,
        8066,
        937,
        2053,
        8564
    ],
    "balangaw": [
        937
    ],
    "boulba": [
        939
    ],
    "bulba": [
        939
    ],
    "burusa": [
        939
    ],
    "balantak": [
        940
    ],
    "bamanankan": [
        941,
        942,
        943
    ],
    "bamanakan": [
        941,
        942,
        943
    ],
    "bamako": [
        941,
        942,
        943,
        1006
    ],
    "bamana": [
        941,
        942,
        943
    ],
    "bambara": [
        941,
        942,
        943,
        1006
    ],
    "biem": [
        946
    ],
    "bam": [
        946
    ],
    "baga manduri": [
        947
    ],
    "baga mandori": [
        947
    ],
    "baga mandouri": [
        947
    ],
    "bamassa": [
        948
    ],
    "bomasa": [
        948
    ],
    "bomassa": [
        948
    ],
    "bom-kim": [
        949
    ],
    "bome": [
        949
    ],
    "bomo": [
        949,
        1022
    ],
    "bum": [
        965,
        949
    ],
    "bamwe": [
        950
    ],
    "bemal": [
        951
    ],
    "bagirmi": [
        952,
        2489
    ],
    "baghirmi": [
        952,
        2489
    ],
    "bagrimma": [
        952
    ],
    "baguirme": [
        952
    ],
    "baguirmi": [
        952
    ],
    "barma": [
        952
    ],
    "bote": [
        953
    ],
    "bot": [
        953
    ],
    "bote-majhi": [
        953
    ],
    "boanai": [
        954
    ],
    "boanaki": [
        954
    ],
    "boianaki": [
        954
    ],
    "boinaki": [
        954
    ],
    "bomboli": [
        955
    ],
    "bombongo": [
        955
    ],
    "betsimisaraka": [
        956,
        1298,
        4736
    ],
    "bina": [
        957,
        1280
    ],
    "bina (papua new guinea)": [
        957
    ],
    "bambalang": [
        958
    ],
    "bambolang": [
        958
    ],
    "bulgebi": [
        959
    ],
    "bomu": [
        960,
        1991
    ],
    "boomu": [
        960
    ],
    "bobo oule": [
        960
    ],
    "bobo wule": [
        960
    ],
    "boore": [
        960
    ],
    "boré": [
        960
    ],
    "bwamu": [
        1231,
        1246,
        1022,
        960
    ],
    "bora-muinane": [
        961
    ],
    "bilma": [
        962
    ],
    "bilma kanuri": [
        962
    ],
    "bla bla": [
        962
    ],
    "bla": [
        962
    ],
    "biao mon": [
        963
    ],
    "biao mien": [
        963
    ],
    "biao-mian": [
        963
    ],
    "biaoman": [
        963
    ],
    "byaumon": [
        963
    ],
    "bulum": [
        964
    ],
    "burum": [
        964,
        1193
    ],
    "burum-mindik": [
        964
    ],
    "bomwali": [
        966
    ],
    "bomali": [
        966
    ],
    "boumoali": [
        966
    ],
    "bumali": [
        966
    ],
    "baimak": [
        967,
        2527
    ],
    "baramu": [
        968,
        1082
    ],
    "bengali": [
        969,
        970,
        971,
        972,
        3224,
        7271,
        7272,
        7273,
        1661,
        1662,
        1663,
        5288
    ],
    "bangla": [
        969,
        970,
        971,
        972,
        3224,
        6537,
        7271,
        7272,
        7273
    ],
    "bangla-bhasa": [
        969,
        970,
        972
    ],
    "bonerate": [
        973
    ],
    "bookan": [
        974
    ],
    "baukan": [
        974
    ],
    "baukan murut": [
        974
    ],
    "bontok": [
        975,
        2053,
        5827,
        6487,
        8066
    ],
    "bontoc igorot": [
        975
    ],
    "bontok, central": [
        975
    ],
    "banda (indonesia)": [
        976
    ],
    "bintauna": [
        977
    ],
    "bintaoena": [
        977
    ],
    "bintawoena": [
        977
    ],
    "bitaoena": [
        977
    ],
    "bonfia": [
        978
    ],
    "benga": [
        979
    ],
    "boumba": [
        979
    ],
    "bangi": [
        980,
        1747
    ],
    "bobangi": [
        980
    ],
    "bubangi": [
        980
    ],
    "bungi": [
        980
    ],
    "barangan": [
        981
    ],
    "binatangan": [
        981
    ],
    "bierebo": [
        982
    ],
    "bonkovia-yevali": [
        982
    ],
    "boon": [
        983,
        1005
    ],
    "bapuku": [
        984
    ],
    "batanga": [
        984
    ],
    "bapoko": [
        984
    ],
    "bapuu": [
        984
    ],
    "batanga-banda": [
        984
    ],
    "bunun": [
        985
    ],
    "bubukun": [
        985
    ],
    "bunti": [
        985
    ],
    "bunum": [
        985
    ],
    "bantoanon": [
        986
    ],
    "binisaya": [
        986,
        1409,
        1410,
        3935,
        8165,
        8166
    ],
    "bisaya": [
        1117,
        1143,
        986,
        1409,
        1410,
        3935
    ],
    "bola": [
        987,
        1251,
        3825,
        8883,
        8885,
        8889
    ],
    "bola-bakovi": [
        987
    ],
    "bakovi": [
        987
    ],
    "bantik": [
        988
    ],
    "banti’": [
        988
    ],
    "butmas-tur": [
        989
    ],
    "bundeli": [
        990
    ],
    "bondili": [
        990
    ],
    "bundelkhandi": [
        990
    ],
    "bentong": [
        991
    ],
    "bentong-dentong": [
        991
    ],
    "beneraf": [
        992
    ],
    "boneraf": [
        992
    ],
    "bonerif": [
        992
    ],
    "bisis": [
        993
    ],
    "bises": [
        993
    ],
    "bangubangu": [
        994
    ],
    "bangobango": [
        994
    ],
    "bintulu": [
        995
    ],
    "beezen": [
        996
    ],
    "bezen": [
        996
    ],
    "bod": [
        997,
        1000,
        1001,
        4498
    ],
    "bod skad": [
        997,
        1000,
        1001
    ],
    "bora": [
        1002
    ],
    "booraa": [
        1002
    ],
    "bora-miranya": [
        1002
    ],
    "boro": [
        1109,
        1110,
        1111,
        8702,
        1002,
        1236,
        1237
    ],
    "buu": [
        1004,
        9001
    ],
    "bolon": [
        1005
    ],
    "boka": [
        1005,
        1217
    ],
    "boron": [
        1005
    ],
    "bamako sign language": [
        1006
    ],
    "boma": [
        1007,
        2054
    ],
    "boma kasai": [
        1007
    ],
    "buma": [
        1007,
        7553,
        7800
    ],
    "barbareño": [
        1008
    ],
    "bogadjim": [
        1009
    ],
    "bogajim": [
        1009
    ],
    "bogati": [
        1009
    ],
    "bonjo": [
        1010
    ],
    "bole": [
        1011
    ],
    "bolanchi": [
        1011
    ],
    "bolanci": [
        1011
    ],
    "bolawa": [
        1011
    ],
    "bolewa": [
        1011
    ],
    "berom": [
        1012
    ],
    "bèrom": [
        1012
    ],
    "baho": [
        1012
    ],
    "berum": [
        1012
    ],
    "birom": [
        1012
    ],
    "bine": [
        1013
    ],
    "bozo, tiemacèwè": [
        1014
    ],
    "bozo": [
        1014,
        1024,
        1025,
        1300,
        1301,
        1320
    ],
    "boso": [
        1014,
        1024,
        1025,
        1300,
        1301,
        1320
    ],
    "bonkiman": [
        1015
    ],
    "bogaya": [
        1016
    ],
    "bogaia": [
        1016
    ],
    "borôro": [
        1017
    ],
    "boe wadáru": [
        1017
    ],
    "bororo": [
        1017
    ],
    "böngö": [
        1018
    ],
    "bondei": [
        1019
    ],
    "bonde": [
        1019,
        5725
    ],
    "boondei": [
        1019
    ],
    "bawuli": [
        1020
    ],
    "boviri": [
        1020
    ],
    "bowili": [
        1020
    ],
    "bowiri": [
        1020
    ],
    "bowuri": [
        1020
    ],
    "bothar": [
        1021
    ],
    "buamu": [
        1022,
        1231
    ],
    "bouamou": [
        1022
    ],
    "bwaba": [
        1022
    ],
    "bodo (central african republic)": [
        1023
    ],
    "bozo, tieyaxo": [
        1024,
        1025
    ],
    "baiap": [
        1026
    ],
    "barbacoas": [
        1027
    ],
    "banda-banda": [
        1028
    ],
    "bauni": [
        1029
    ],
    "barapu": [
        1029
    ],
    "barupu": [
        1029
    ],
    "bonggo": [
        1030
    ],
    "bgu": [
        1030
    ],
    "bogu": [
        1030
    ],
    "botlikh": [
        1031
    ],
    "botlix": [
        1031
    ],
    "buykhadi": [
        1031
    ],
    "bagupi": [
        1032
    ],
    "binji": [
        1033
    ],
    "bindji": [
        1033
    ],
    "boewe": [
        1034
    ],
    "boewi": [
        1034
    ],
    "broome pearling lugger pidgin": [
        1035
    ],
    "broome": [
        1035
    ],
    "broom creole": [
        1035
    ],
    "broom": [
        1035
    ],
    "biyom": [
        1036
    ],
    "ba pai yao": [
        1037
    ],
    "bapu": [
        1038
    ],
    "banda malay": [
        1040
    ],
    "blaan, koronadal": [
        1041
    ],
    "blaan": [
        1041,
        1042
    ],
    "baraan": [
        1041
    ],
    "bilanes": [
        1041
    ],
    "biraan": [
        1041
    ],
    "bilaan": [
        1042,
        1041
    ],
    "b’laan": [
        1041
    ],
    "blaan, sarangani": [
        1042
    ],
    "balud": [
        1042
    ],
    "barrow point": [
        1043
    ],
    "barrow": [
        1043
    ],
    "bongu": [
        1044
    ],
    "bian": [
        1045
    ],
    "bian marind": [
        1045
    ],
    "boven-mbian": [
        1045
    ],
    "bo (papua new guinea)": [
        1046
    ],
    "bareli, palya": [
        1047
    ],
    "bishnupuriya": [
        1048
    ],
    "bishnupria": [
        1048
    ],
    "bishnupria manipuri": [
        1048
    ],
    "bishnupriya": [
        1048
    ],
    "bishnupriya manipuri": [
        1048
    ],
    "bisna puriya": [
        1048
    ],
    "bisna": [
        1048
    ],
    "bilba": [
        1049
    ],
    "belubaa": [
        1049
    ],
    "bilbaa": [
        1049
    ],
    "bagusa": [
        1051
    ],
    "bo'o": [
        1052
    ],
    "boko (benin)": [
        1052
    ],
    "bokonya": [
        1052
    ],
    "boo": [
        1052,
        2054
    ],
    "bo’o": [
        1052,
        2012
    ],
    "bung": [
        1053,
        3710
    ],
    "baga kaloum": [
        1054,
        1055
    ],
    "bago-kusuntu": [
        1056
    ],
    "bagó": [
        1056
    ],
    "baima": [
        1057
    ],
    "bai ma": [
        1057
    ],
    "bakhtiâri": [
        1058
    ],
    "bakhtiari": [
        1058
    ],
    "bandial": [
        1059
    ],
    "banjaal": [
        1059
    ],
    "banjal": [
        1059
    ],
    "banda-mbrès": [
        1060
    ],
    "banda of mbrès": [
        1060
    ],
    "banda-mbre": [
        1060
    ],
    "bilakura": [
        1061
    ],
    "bamboko": [
        1062
    ],
    "bambuku": [
        1062
    ],
    "bomboko": [
        1062
    ],
    "bumboko": [
        1062
    ],
    "bulgarian sign language": [
        1063
    ],
    "balgarski žestomimičen ezik": [
        1063
    ],
    "balgarski": [
        1063
    ],
    "bže": [
        1063
    ],
    "balo": [
        1064
    ],
    "bisã": [
        1065
    ],
    "bisayã": [
        1065
    ],
    "boussa": [
        1065
    ],
    "busa-bisã": [
        1065
    ],
    "busano": [
        1065
    ],
    "bussanchi": [
        1065,
        1188
    ],
    "bussawa": [
        1065,
        1188
    ],
    "biritai": [
        1066
    ],
    "biri": [
        1314,
        1066,
        1204,
        1212
    ],
    "burusu": [
        1067
    ],
    "berusuh": [
        1067
    ],
    "bulusu": [
        1067
    ],
    "bosmun": [
        1068
    ],
    "bosman": [
        1068
    ],
    "bosngun": [
        1068
    ],
    "bamukumbit": [
        1069
    ],
    "bamenkombit": [
        1069
    ],
    "bamenkoumbit": [
        1069
    ],
    "bamoukoumbit": [
        1069
    ],
    "bamunkum": [
        1069
    ],
    "bamunkumbit": [
        1069
    ],
    "boguru": [
        1070
    ],
    "buguru": [
        1070
    ],
    "begbere-ejar": [
        1071
    ],
    "buru": [
        1072,
        4783,
        4247,
        5278,
        7361
    ],
    "buru (nigeria)": [
        1072
    ],
    "baangi": [
        1073
    ],
    "bengkala sign language": [
        1074
    ],
    "bengkala": [
        1074
    ],
    "benkala sign language": [
        1074
    ],
    "benkala": [
        1074
    ],
    "bakaka": [
        1075
    ],
    "breton": [
        1076,
        5832,
        8420
    ],
    "brezhoneg": [
        1076
    ],
    "braj bhasha": [
        1077
    ],
    "bijbhasha": [
        1077
    ],
    "braj bhakha": [
        1077
    ],
    "bri": [
        1077,
        7284
    ],
    "brij bhasha": [
        1077
    ],
    "brij": [
        1077
    ],
    "briju": [
        1077
    ],
    "bruj": [
        1077
    ],
    "brao": [
        1078,
        1080,
        1079,
        3941
    ],
    "braou": [
        1078,
        1079,
        1080
    ],
    "brau": [
        1078,
        1079,
        1080
    ],
    "brou": [
        1078,
        1079,
        1080,
        1100,
        1101,
        1102
    ],
    "berbice dutch creole": [
        1081
    ],
    "berbice": [
        1081
    ],
    "berbice creole dutch": [
        1081
    ],
    "baram": [
        1082,
        4150
    ],
    "balkura": [
        1082
    ],
    "baraamu": [
        1082
    ],
    "baramo": [
        1082
    ],
    "brahmu": [
        1082
    ],
    "bera": [
        1083
    ],
    "baure": [
        1084
    ],
    "brahui": [
        1085,
        1086
    ],
    "barahui": [
        1085
    ],
    "birahui": [
        1085,
        1086
    ],
    "biravi": [
        1085
    ],
    "brahudi": [
        1085
    ],
    "brahuidi": [
        1085,
        1086
    ],
    "brahuigi": [
        1085,
        1086
    ],
    "brahuiki": [
        1085
    ],
    "bakpwe": [
        1087
    ],
    "bakueri": [
        1087
    ],
    "bakwedi": [
        1087
    ],
    "bakweri": [
        1087
    ],
    "bakwiri": [
        1087
    ],
    "bekwiri": [
        1087
    ],
    "bieria": [
        1088
    ],
    "birked": [
        1089
    ],
    "birgid": [
        1089,
        1149
    ],
    "birguid": [
        1089
    ],
    "birkit": [
        1089
    ],
    "birqed": [
        1089
    ],
    "birwa": [
        1090
    ],
    "bw": [
        1090,
        2132,
        2713,
        2849,
        2950,
        3003,
        3073,
        4786,
        5460,
        5576,
        6835,
        7614,
        7830,
        7874,
        8511,
        8780
    ],
    "botswana": [
        1090,
        2132,
        2713,
        2849,
        2950,
        3003,
        3073,
        4786,
        5460,
        5576,
        6835,
        7614,
        7830,
        7874,
        8511,
        8780
    ],
    "barambu": [
        1091
    ],
    "balambu": [
        1091
    ],
    "barambo": [
        1091
    ],
    "boruca": [
        1092
    ],
    "boruka": [
        1092
    ],
    "borunca": [
        1092
    ],
    "bronca": [
        1092
    ],
    "brunca": [
        1092
    ],
    "brunka": [
        1092
    ],
    "burunca": [
        1092
    ],
    "brokkat": [
        1093,
        1094
    ],
    "brokskad": [
        1093,
        1094
    ],
    "bt": [
        1093,
        1094,
        1436,
        1886,
        2044,
        2048,
        2727,
        3727,
        4319,
        4362,
        4525,
        4561,
        5396,
        5642,
        5893,
        6823,
        7309,
        7310,
        7451,
        7738,
        8497,
        8515,
        8516
    ],
    "bhutan": [
        2044,
        1093,
        1094,
        1436,
        1886,
        2048,
        2727,
        3727,
        4319,
        4362,
        4525,
        4561,
        5396,
        5642,
        5893,
        6823,
        7309,
        7310,
        7451,
        7738,
        8497,
        8515,
        8516
    ],
    "barapasi": [
        1095
    ],
    "baropasi": [
        1095
    ],
    "breri": [
        1096,
        6469
    ],
    "bnyoqko": [
        1096
    ],
    "birao": [
        1097
    ],
    "baras": [
        1098
    ],
    "bitare": [
        1099
    ],
    "bru, eastern": [
        1100,
        1101,
        1102
    ],
    "bru": [
        1100,
        1101,
        1102,
        1103,
        1104,
        1105,
        1106,
        6517,
        7147,
        7148,
        7477
    ],
    "bru tri": [
        1100,
        1101,
        1102
    ],
    "bru van kieu": [
        1100,
        1101,
        1102
    ],
    "brũ": [
        1100,
        1101,
        1102
    ],
    "bru, western": [
        1103,
        1104,
        1105,
        1106
    ],
    "baru": [
        1103,
        1104,
        1105,
        1106,
        4172
    ],
    "bruu": [
        1103,
        1104,
        1105,
        1106
    ],
    "b’ru": [
        1103,
        1104,
        1105,
        1106
    ],
    "bru dong luang": [
        1104
    ],
    "bru khong chiem": [
        1105
    ],
    "bru sakon nakhorn": [
        1106
    ],
    "bellari": [
        1107,
        1108
    ],
    "bodi": [
        1109,
        1110,
        1111
    ],
    "bodo (india)": [
        1109,
        1110,
        1111
    ],
    "boroni": [
        1109,
        1110,
        1111
    ],
    "burui": [
        1112
    ],
    "bilbil": [
        1113
    ],
    "bel": [
        1113,
        2578
    ],
    "bilibil": [
        1113
    ],
    "bosnian": [
        1114,
        1115,
        8906
    ],
    "bosanski": [
        1114,
        8906
    ],
    "bosnia and herzegovina": [
        1114,
        1115,
        3043,
        7089,
        7093
    ],
    "bosnia": [
        1114,
        1115,
        3043,
        7089,
        7093
    ],
    "bisaya, brunei": [
        1117
    ],
    "basaya": [
        1117,
        1143
    ],
    "bekiau": [
        1117
    ],
    "besaya": [
        1117,
        1143
    ],
    "bisaia": [
        1117,
        1143
    ],
    "bisaya bukit": [
        1117
    ],
    "bukit": [
        1215,
        1117,
        1953,
        3838,
        3839
    ],
    "bisayah": [
        1117,
        1143
    ],
    "brunei bisaya": [
        1117
    ],
    "bawang": [
        2251,
        1117,
        1143,
        4425
    ],
    "basari": [
        1118,
        1173,
        1174,
        7629
    ],
    "bassari": [
        1118,
        1173,
        1174
    ],
    "bassari-tanda": [
        1118
    ],
    "biyan": [
        1118
    ],
    "babessi": [
        1119
    ],
    "bauchi": [
        1120,
        9001
    ],
    "bauchi-guda": [
        1120
    ],
    "bauci": [
        1120
    ],
    "baushi": [
        1120
    ],
    "bashkardi": [
        1121
    ],
    "bashaka": [
        1121
    ],
    "bashgali": [
        1122
    ],
    "bassossi": [
        1123
    ],
    "basosi": [
        1123
    ],
    "basossi": [
        1123
    ],
    "bangwinji": [
        1124
    ],
    "bangjinge": [
        1124
    ],
    "bangunje": [
        1124
    ],
    "bangunji": [
        1124
    ],
    "burushaski": [
        1125,
        1126
    ],
    "biltum": [
        1125,
        1126
    ],
    "brooshaaski": [
        1125,
        1126
    ],
    "brushaski": [
        1125,
        1126
    ],
    "burucaki": [
        1125,
        1126
    ],
    "burucaski": [
        1125,
        1126
    ],
    "burushaki": [
        1125,
        1126
    ],
    "burushaski hunza": [
        1125,
        1126
    ],
    "burushki": [
        1125,
        1126
    ],
    "basa-gumna": [
        1127
    ],
    "basa kuta": [
        1127
    ],
    "basa-kaduna": [
        1127
    ],
    "bassa-kaduna": [
        1127
    ],
    "bassa-kuta": [
        1127
    ],
    "busami": [
        1128
    ],
    "barasana-eduria": [
        1129
    ],
    "banera yae": [
        1129
    ],
    "banera": [
        1129
    ],
    "barasano del sur": [
        1129
    ],
    "buso": [
        1130
    ],
    "bousso": [
        1130
    ],
    "busso": [
        1130
    ],
    "baga sitemu": [
        1131
    ],
    "bassa-kontagora": [
        1134
    ],
    "bafaramani": [
        1135
    ],
    "bakosi": [
        1135
    ],
    "bakossi": [
        1135
    ],
    "bekoose": [
        1135
    ],
    "basketo": [
        1136,
        1137
    ],
    "bahonsuai": [
        1138
    ],
    "bahoe-soeaai": [
        1138
    ],
    "bahonsoewaai": [
        1138
    ],
    "baga sobané": [
        1139,
        1140
    ],
    "baga kakissa": [
        1139,
        1140
    ],
    "baiso": [
        1141
    ],
    "bashar": [
        1142
    ],
    "basharawa": [
        1142
    ],
    "bashiri": [
        1142
    ],
    "bisaya, sabah": [
        1143
    ],
    "bata": [
        1144
    ],
    "birsa": [
        1144
    ],
    "beti (cameroon)": [
        1145
    ],
    "beti": [
        1145,
        2244
    ],
    "bati": [
        1146,
        1214,
        3852
    ],
    "bati (cameroon)": [
        1146
    ],
    "bati ba ngong": [
        1146
    ],
    "bati de brousse": [
        1146
    ],
    "brousse": [
        1146
    ],
    "batak dairi": [
        1147
    ],
    "birgit": [
        1149
    ],
    "bergit": [
        1149
    ],
    "berguid": [
        1149
    ],
    "bété, gagnoa": [
        1150
    ],
    "bidayuh, biatah": [
        1151
    ],
    "bidayuh": [
        1151,
        6759,
        6993,
        7724
    ],
    "biatah": [
        1151
    ],
    "biatah bidayuh": [
        1151
    ],
    "bideyu": [
        1151
    ],
    "bikuab": [
        1151
    ],
    "burate": [
        1152
    ],
    "bacanese": [
        1153
    ],
    "bacan": [
        1153
    ],
    "bacanese malay": [
        1153
    ],
    "batjan": [
        1153
    ],
    "batak mandailing": [
        1154
    ],
    "bikol, rinconada": [
        1156
    ],
    "bicol-rinconada": [
        1156
    ],
    "bikol-rinconada": [
        1156
    ],
    "budibud": [
        1157
    ],
    "batek": [
        1158
    ],
    "bateg": [
        1158
    ],
    "bateq": [
        1158
    ],
    "batok": [
        1158
    ],
    "baetora": [
        1159
    ],
    "batak simalungun": [
        1160,
        1161
    ],
    "bete-bendi": [
        1162
    ],
    "bette-bendi": [
        1162
    ],
    "batu": [
        1163,
        6234,
        5468,
        8997
    ],
    "bateri": [
        1164
    ],
    "batera kohistani": [
        1164
    ],
    "batera": [
        1164
    ],
    "baterawal": [
        1164
    ],
    "baterawal kohistani": [
        1164
    ],
    "bateri kohistani": [
        1164
    ],
    "butuanon": [
        1165
    ],
    "batak karo": [
        1166,
        1167
    ],
    "bobot": [
        1168
    ],
    "batak alas-kluet": [
        1169
    ],
    "buriat": [
        1170,
        1259,
        1260,
        1261,
        1267
    ],
    "buriat, russia": [
        1170
    ],
    "buriat-mongolian": [
        1170,
        1259,
        1260,
        1261,
        1267
    ],
    "buryat": [
        1170,
        1259,
        1260,
        1261,
        1267
    ],
    "bua": [
        1171,
        1244
    ],
    "boa": [
        1171,
        1244
    ],
    "boua": [
        1171,
        1244
    ],
    "bushi": [
        1172
    ],
    "basar": [
        1173,
        1174
    ],
    "basare": [
        1173,
        1174
    ],
    "bassar": [
        1173,
        1174
    ],
    "beothuk": [
        1175
    ],
    "bushoong": [
        1176
    ],
    "bakuba": [
        1176
    ],
    "bamongo": [
        1176
    ],
    "bukuba": [
        1176
    ],
    "bushona": [
        1176
    ],
    "bushong": [
        1176
    ],
    "bushonga": [
        1176
    ],
    "bushongo": [
        1176
    ],
    "busoong": [
        1176
    ],
    "bugis": [
        1177,
        1178
    ],
    "basa ugi": [
        1177,
        1178
    ],
    "boegineesche": [
        1177,
        1178
    ],
    "boeginezen": [
        1177,
        1178
    ],
    "bugi": [
        1177,
        1178
    ],
    "buginese": [
        1177,
        1178
    ],
    "bunu, younuo": [
        1179
    ],
    "bongili": [
        1180
    ],
    "bokiba": [
        1180
    ],
    "bongiri": [
        1180
    ],
    "bonguili": [
        1180
    ],
    "bungili": [
        1180
    ],
    "bungiri": [
        1180
    ],
    "basa-gurmana": [
        1181
    ],
    "bugawac": [
        1182
    ],
    "bukaua": [
        1182
    ],
    "bukawa": [
        1182
    ],
    "bukawac": [
        1182
    ],
    "boulou": [
        1183
    ],
    "bulu (cameroon)": [
        1183
    ],
    "bullom": [
        1194,
        1184
    ],
    "buin": [
        1185,
        5430
    ],
    "busoa": [
        1186
    ],
    "bosoa": [
        1186
    ],
    "brem": [
        1187
    ],
    "barem": [
        1187
    ],
    "bububun": [
        1187
    ],
    "bunabun": [
        1187
    ],
    "bunubun": [
        1187
    ],
    "bokobaru": [
        1188
    ],
    "busa-bokobaru": [
        1188
    ],
    "bungain": [
        1189
    ],
    "budu": [
        1190
    ],
    "bun": [
        1191,
        2676
    ],
    "bubi": [
        1192,
        1197
    ],
    "bhubhi": [
        1192
    ],
    "boghom": [
        1193
    ],
    "bogghom": [
        1193
    ],
    "boghorom": [
        1193
    ],
    "bohom": [
        1193
    ],
    "bokiyim": [
        1193
    ],
    "borrom": [
        1193
    ],
    "burma": [
        1193
    ],
    "burom": [
        1193
    ],
    "burrum": [
        1193
    ],
    "burumawa": [
        1193
    ],
    "bullom so": [
        1194
    ],
    "bolom": [
        1194
    ],
    "bulem": [
        1194
    ],
    "bullin": [
        1194
    ],
    "bullun": [
        1194
    ],
    "bukwen": [
        1195
    ],
    "barein": [
        1196
    ],
    "barayin": [
        1196
    ],
    "baraïn": [
        1196
    ],
    "bube": [
        1197
    ],
    "boobe": [
        1197
    ],
    "boombe": [
        1197
    ],
    "baelelea": [
        1198
    ],
    "baeggu": [
        1199
    ],
    "baegu": [
        1199
    ],
    "berau": [
        1200,
        7012
    ],
    "berau malay": [
        1200
    ],
    "boor": [
        1201
    ],
    "bwara": [
        1201
    ],
    "bonkeng": [
        1202
    ],
    "bongken": [
        1202
    ],
    "bonkeng-pendia": [
        1202
    ],
    "bonkenge": [
        1202
    ],
    "bure": [
        1203,
        5333
    ],
    "bubure": [
        1203,
        8145
    ],
    "belanda viri": [
        1204
    ],
    "belanda": [
        1204,
        1249
    ],
    "bviri": [
        1204,
        1212
    ],
    "baan": [
        1205,
        4735
    ],
    "baan-ogoi": [
        1205
    ],
    "bukat": [
        1206,
        1215
    ],
    "bolivian sign language": [
        1207
    ],
    "bolivian": [
        1207,
        2721,
        2810,
        6404,
        5116,
        6394
    ],
    "bamunka": [
        1208
    ],
    "bamunkun": [
        1208
    ],
    "bolgo": [
        1210
    ],
    "bumang": [
        1211
    ],
    "birri": [
        1212
    ],
    "burarra": [
        1213
    ],
    "barera": [
        1213
    ],
    "bawera": [
        1213
    ],
    "burada": [
        1213,
        1833
    ],
    "bureda": [
        1213
    ],
    "burera": [
        1213
    ],
    "bati (indonesia)": [
        1214
    ],
    "bukit malay": [
        1215
    ],
    "baniva": [
        1216,
        1230,
        2512,
        3875,
        4921
    ],
    "banibo": [
        1216,
        1230
    ],
    "baniva yavitero": [
        1216
    ],
    "boga": [
        1217
    ],
    "babole": [
        1218
    ],
    "bomitaba": [
        9104,
        1218
    ],
    "baybayanon": [
        1219
    ],
    "bauzi": [
        1220
    ],
    "baudi": [
        1220
    ],
    "baudji": [
        1220
    ],
    "baudzi": [
        1220
    ],
    "bauri": [
        1220
    ],
    "bwatoo": [
        1221
    ],
    "bwile": [
        1223
    ],
    "bwaidoka": [
        1224
    ],
    "bwaidoga": [
        1224
    ],
    "bwe": [
        1225,
        1226,
        4061,
        4062
    ],
    "baghi": [
        1225,
        1226
    ],
    "bghai karen": [
        1225,
        1226
    ],
    "bghai": [
        1225,
        1226
    ],
    "blimaw": [
        1225,
        1226,
        3381
    ],
    "bwe karen": [
        1225,
        1226
    ],
    "boselewa": [
        1227
    ],
    "bosalewa": [
        1227
    ],
    "bosilewa": [
        1227
    ],
    "barwe": [
        1228
    ],
    "balke": [
        1228
    ],
    "bishuo": [
        1229
    ],
    "biyam": [
        1229
    ],
    "baniwa": [
        1230,
        3875
    ],
    "baniba": [
        1230
    ],
    "baniua do içana": [
        1230
    ],
    "baniua": [
        1230
    ],
    "baniwa do içana": [
        1230
    ],
    "bwamu, láá láá": [
        1231
    ],
    "buamu laa": [
        1231
    ],
    "buamu-laa": [
        1231
    ],
    "bwamu laa": [
        1231
    ],
    "bauwaki": [
        1232
    ],
    "bawaki": [
        1232
    ],
    "bwela": [
        1233
    ],
    "buela": [
        1233
    ],
    "biwat": [
        1234
    ],
    "bunu, wunai": [
        1235
    ],
    "borna": [
        1236,
        1237
    ],
    "borna (ethiopia)": [
        1236,
        1237
    ],
    "boro (ethiopia)": [
        1236,
        1237
    ],
    "bawah": [
        1238,
        8555
    ],
    "bobo madaré, southern": [
        1239
    ],
    "bobo fing": [
        1239
    ],
    "bura-pabir": [
        1240
    ],
    "babir": [
        1240
    ],
    "babur": [
        1240
    ],
    "barburr": [
        1240
    ],
    "bourrah": [
        1240
    ],
    "bura": [
        1240,
        4655,
        4656
    ],
    "burra": [
        1240,
        3431
    ],
    "bomboma": [
        1241
    ],
    "boba": [
        1241
    ],
    "bafaw-balong": [
        1242
    ],
    "buli": [
        1243,
        1313,
        1661,
        1662,
        1663
    ],
    "builsa": [
        1243
    ],
    "buli (ghana)": [
        1243
    ],
    "bulisa": [
        1243
    ],
    "bulsa": [
        1243
    ],
    "bunu, bu-nao": [
        1245
    ],
    "bu-nao": [
        1245
    ],
    "bu-nao bunu": [
        1245
    ],
    "bunao": [
        1245
    ],
    "bwamu, cwi": [
        1246
    ],
    "bwisi": [
        1247,
        7570
    ],
    "bauro": [
        1248
    ],
    "bwauro": [
        1248
    ],
    "belanda bor": [
        1249
    ],
    "balengue": [
        1250
    ],
    "bela": [
        1251
    ],
    "bula": [
        1251,
        4575,
        4719
    ],
    "bilur": [
        1253
    ],
    "birar": [
        1253
    ],
    "buhutu": [
        1255
    ],
    "bohutu": [
        1255
    ],
    "buhulu": [
        1255
    ],
    "biladaba": [
        1256
    ],
    "bayungu": [
        1257
    ],
    "baijungu": [
        1257
    ],
    "baiong": [
        1257
    ],
    "baiung": [
        1257
    ],
    "bajungu": [
        1257
    ],
    "biong": [
        1257
    ],
    "blé": [
        1258
    ],
    "buriat, mongolia": [
        1259,
        1260,
        1261
    ],
    "burraad": [
        1259,
        1260,
        1261
    ],
    "burduna": [
        1262
    ],
    "boordoona": [
        1262
    ],
    "budina": [
        1262
    ],
    "budoona": [
        1262
    ],
    "buduna": [
        1262
    ],
    "barikanchi": [
        1263
    ],
    "bebil": [
        1264
    ],
    "bobilis": [
        1264
    ],
    "beele": [
        1265
    ],
    "bele": [
        1265
    ],
    "bellawa": [
        1265
    ],
    "busam": [
        1266
    ],
    "buriat, china": [
        1267
    ],
    "bargu buriat": [
        1267
    ],
    "ba’erhu-buliyate": [
        1267
    ],
    "berakou": [
        1268
    ],
    "bubalia": [
        1268
    ],
    "bankagooma": [
        1269
    ],
    "banka": [
        1269
    ],
    "bankagoma": [
        1269
    ],
    "bankagoroma": [
        1269
    ],
    "bankaje": [
        1269
    ],
    "binahari": [
        1270
    ],
    "binahari-neme": [
        1270
    ],
    "babuyan": [
        1271,
        3288
    ],
    "bikya": [
        1272
    ],
    "benyadu’": [
        1274
    ],
    "balantian": [
        1274
    ],
    "balantiang": [
        1274
    ],
    "benyadu'": [
        1274
    ],
    "bouye": [
        1275
    ],
    "baygo": [
        1277
    ],
    "baigo": [
        1277
    ],
    "bego": [
        1277
    ],
    "beigo": [
        1277
    ],
    "beko": [
        1277,
        5499
    ],
    "beygo": [
        1277
    ],
    "béogé": [
        1277
    ],
    "bhujel": [
        1278
    ],
    "bujal": [
        1278
    ],
    "bujhel": [
        1278
    ],
    "bujheli": [
        1278
    ],
    "bujhyal": [
        1278
    ],
    "buyu": [
        1279
    ],
    "bujwe": [
        1279
    ],
    "buyi": [
        1279,
        6062,
        6063,
        9146,
        9147
    ],
    "bin": [
        1280
    ],
    "bina (nigeria)": [
        1280
    ],
    "binawa": [
        1280
    ],
    "bogana": [
        1280
    ],
    "beu": [
        1281
    ],
    "bayono": [
        1282
    ],
    "benanu": [
        1282
    ],
    "bese": [
        1282
    ],
    "bidjara": [
        1283
    ],
    "bidyara": [
        1283
    ],
    "bithara": [
        1283
    ],
    "bitjara": [
        1283
    ],
    "bilen": [
        1284,
        1285
    ],
    "balen": [
        1284,
        1285
    ],
    "belen": [
        1284,
        1285
    ],
    "beleni": [
        1284,
        1285
    ],
    "bilayn": [
        1284,
        1285
    ],
    "bilein": [
        1284,
        1285
    ],
    "bilene": [
        1284,
        1285
    ],
    "bileno": [
        1284,
        1285
    ],
    "bilin": [
        1284,
        1285
    ],
    "blin": [
        1285,
        1284
    ],
    "bogos": [
        1284,
        1285
    ],
    "biyo": [
        1286
    ],
    "bio": [
        1286
    ],
    "biyue": [
        1286
    ],
    "bumaji": [
        1287
    ],
    "basay": [
        1288,
        3463
    ],
    "basai": [
        1288
    ],
    "basay-trobiawan": [
        1288
    ],
    "barua": [
        1289,
        2254
    ],
    "baruya": [
        1289
    ],
    "burak": [
        1290
    ],
    "buurak": [
        1290
    ],
    "berti": [
        1291
    ],
    "bagangte": [
        1292
    ],
    "bamileke-medumba": [
        1292
    ],
    "bangangte": [
        1292
    ],
    "belhariya": [
        1293
    ],
    "belhare": [
        1293
    ],
    "baining": [
        1294,
        2565
    ],
    "banar": [
        1295,
        6931
    ],
    "banara": [
        1295,
        6091,
        7620
    ],
    "banaro": [
        1295
    ],
    "bandi": [
        1296
    ],
    "bandí": [
        1296
    ],
    "bande": [
        1296,
        7629
    ],
    "bribri": [
        1299
    ],
    "bozo, jenaama": [
        1300,
        1301
    ],
    "boikin": [
        1302
    ],
    "boiken": [
        1302
    ],
    "babuza": [
        1303
    ],
    "babusa": [
        1303
    ],
    "buang, mapos": [
        1304
    ],
    "buang": [
        1304,
        4915,
        6346
    ],
    "bisu": [
        1305,
        4553
    ],
    "belize english creole": [
        1306
    ],
    "belize": [
        1306,
        2133,
        2261,
        4971
    ],
    "belize kriol english": [
        1306
    ],
    "bz": [
        1306,
        2133,
        2261,
        4971
    ],
    "boano": [
        1308,
        1310
    ],
    "boan-diks": [
        1308
    ],
    "boano (sulawesi)": [
        1308
    ],
    "bolano": [
        1308
    ],
    "bolondo": [
        1309
    ],
    "boano (maluku)": [
        1310
    ],
    "buano": [
        1310
    ],
    "bozaba": [
        1311
    ],
    "budzaba": [
        1311
    ],
    "buzaba": [
        1311
    ],
    "barau": [
        1312
    ],
    "buli (indonesia)": [
        1313
    ],
    "brazilian sign language": [
        1315
    ],
    "brazilian": [
        1315
    ],
    "brasileira": [
        1315,
        7940
    ],
    "brasileiros": [
        1315
    ],
    "brithenig": [
        1316
    ],
    "burmeso": [
        1317
    ],
    "boromeso": [
        1317
    ],
    "borumesso": [
        1317
    ],
    "burumeso": [
        1317
    ],
    "bebe": [
        1318
    ],
    "be": [
        1748,
        3855,
        1318,
        1784,
        2128,
        2419,
        5538,
        6799,
        8077,
        8103,
        8147
    ],
    "basa (nigeria)": [
        1319
    ],
    "basa-benue": [
        1319
    ],
    "bozo, kelengaxo": [
        1320
    ],
    "balegete": [
        1322
    ],
    "belegete": [
        1322
    ],
    "black carib": [
        1329
    ],
    "besïro": [
        1349
    ],
    "bualkhaw": [
        1360
    ],
    "bualkhaw chin": [
        1360
    ],
    "bualkhua": [
        1360
    ],
    "balsapuertino": [
        1366
    ],
    "báda": [
        1368
    ],
    "bára": [
        1368
    ],
    "bisaya’": [
        1369
    ],
    "bhasa": [
        1395,
        1396,
        2891,
        2892,
        5409,
        5410,
        5411,
        5758,
        5759,
        5760,
        5761,
        5762,
        6572,
        7376,
        7377,
        8750
    ],
    "bangba lo": [
        1397
    ],
    "bangba-lwo": [
        1397
    ],
    "bangbani": [
        1397
    ],
    "biken": [
        1422
    ],
    "bachiga": [
        1435
    ],
    "bahororo": [
        1435
    ],
    "bakiga": [
        1435
    ],
    "boetoneezen": [
        1462,
        1463,
        1464
    ],
    "butonese": [
        1462,
        1463,
        1464,
        8263
    ],
    "butung": [
        1462,
        1463,
        1464,
        8263
    ],
    "bhamam": [
        1485,
        1486,
        1487
    ],
    "burgenland croatian": [
        1501
    ],
    "burgenland": [
        1501,
        6542
    ],
    "burgenlandkroatische sprache": [
        1501
    ],
    "burgenlandkroatische": [
        1501
    ],
    "bei": [
        4950,
        1519,
        2973,
        2974,
        2975
    ],
    "bogong": [
        1522
    ],
    "bunong": [
        1535,
        1536,
        1537
    ],
    "bu nong": [
        1535,
        1536
    ],
    "budang": [
        1535,
        1536
    ],
    "budong": [
        1535,
        1536,
        1537
    ],
    "byangskat": [
        1541
    ],
    "byanskat": [
        1541
    ],
    "baungshe": [
        1545
    ],
    "bois": [
        1596,
        1597
    ],
    "bohemian": [
        1627,
        1628
    ],
    "bácuki": [
        1640
    ],
    "bed’ea–katío": [
        1668
    ],
    "bikol, northern catanduanes": [
        1670
    ],
    "bong miew": [
        1680
    ],
    "bong": [
        1680,
        3836
    ],
    "bòng mieu": [
        1680
    ],
    "bòng": [
        1680
    ],
    "blas": [
        1687
    ],
    "bulgar": [
        1699
    ],
    "beri": [
        7284,
        1706,
        4369,
        8975,
        8976,
        8977
    ],
    "bekke": [
        1730
    ],
    "bastar koya": [
        1739
    ],
    "bastar": [
        1739
    ],
    "bison horn maria": [
        1739
    ],
    "bison": [
        1739
    ],
    "bokor": [
        1742
    ],
    "bokorike": [
        1742
    ],
    "bokoruge": [
        1742
    ],
    "bangime": [
        1747
    ],
    "bangana": [
        1747
    ],
    "bangeri me": [
        1747
    ],
    "bangeri": [
        1747
    ],
    "bangeri me dogon": [
        1747
    ],
    "bangerime": [
        1747
    ],
    "bangi me": [
        1747
    ],
    "bulud upi": [
        1754,
        1755
    ],
    "bulud": [
        1754,
        1755
    ],
    "ben": [
        1763,
        4726,
        5446
    ],
    "ben tey": [
        1763
    ],
    "ben tey dogon": [
        1763
    ],
    "bondum": [
        1764
    ],
    "bondum dom dogon": [
        1764
    ],
    "bondum-dom": [
        1764
    ],
    "bankan": [
        1766
    ],
    "bankan tey": [
        1766
    ],
    "bankan tey dogon": [
        1766
    ],
    "bainapi": [
        1767
    ],
    "belgium": [
        1784,
        2128,
        2419,
        5538,
        6799,
        8077,
        8103,
        8147
    ],
    "boleka": [
        1810
    ],
    "bunoge": [
        1814
    ],
    "budu-tagu": [
        1814
    ],
    "bunoge dogon": [
        1814
    ],
    "bambadion-dogoso": [
        1827
    ],
    "bambadion-dokhosié": [
        1827
    ],
    "black dogose": [
        1827
    ],
    "budalpudal": [
        1833
    ],
    "buralbural": [
        1833
    ],
    "buratha": [
        1833
    ],
    "brabori": [
        1847
    ],
    "bape": [
        1852
    ],
    "bumbong": [
        1852
    ],
    "butju": [
        1875
    ],
    "businenge tongo": [
        1878,
        1879
    ],
    "businenge": [
        1878,
        1879
    ],
    "businengee tongo": [
        1878,
        1879
    ],
    "businengee": [
        1878,
        1879
    ],
    "badouma": [
        1896
    ],
    "bosiken": [
        1898
    ],
    "boskien": [
        1898
    ],
    "bericho": [
        1903
    ],
    "blowo": [
        1920
    ],
    "barat": [
        1921,
        1928,
        4287,
        5027,
        6595,
        6919,
        7849,
        7853
    ],
    "baliem valley dani": [
        1925
    ],
    "baliem": [
        1925
    ],
    "barawa": [
        1947
    ],
    "bajau bukit": [
        1953
    ],
    "bajau pa’par": [
        1953
    ],
    "baagandji": [
        1960
    ],
    "bagandji": [
        1960
    ],
    "banga": [
        1966
    ],
    "bantalang": [
        1966
    ],
    "bantaurang": [
        1966
    ],
    "bas sorabe": [
        1968
    ],
    "bas": [
        1968,
        2019,
        2020
    ],
    "bomu tegu": [
        1991
    ],
    "bro": [
        2012
    ],
    "bo’": [
        2012
    ],
    "buwane": [
        2022
    ],
    "baby gumatj": [
        2029
    ],
    "baby": [
        2029
    ],
    "boorkutti": [
        2037
    ],
    "burgadi": [
        2037
    ],
    "bulum-bulum": [
        2043
    ],
    "bhotia of bhutan": [
        2044
    ],
    "bhotia of dukpa": [
        2044
    ],
    "bhutanese": [
        2044
    ],
    "beginci": [
        2051
    ],
    "bihak": [
        2051
    ],
    "bontok, eastern": [
        2053
    ],
    "bamboma": [
        2054
    ],
    "boõ": [
        2054
    ],
    "bolognese": [
        2068
    ],
    "belibi": [
        2084
    ],
    "belip": [
        2084
    ],
    "blabla": [
        2094
    ],
    "bedea": [
        2109
    ],
    "bed’ea": [
        2109
    ],
    "basque caló": [
        2115
    ],
    "basque": [
        2316,
        2115
    ],
    "basque romani": [
        2115
    ],
    "bi": [
        2129,
        2421,
        4490,
        6566,
        6567
    ],
    "burundi": [
        2129,
        2421,
        4490,
        6566,
        6567
    ],
    "bm": [
        2130
    ],
    "bermuda": [
        2130
    ],
    "british english": [
        2153
    ],
    "british indian ocean territory": [
        2166
    ],
    "british virgin islands": [
        2220
    ],
    "bai enets": [
        2231
    ],
    "bay enets": [
        2231
    ],
    "beti (côte d'ivoire)": [
        2244
    ],
    "bopa": [
        2251
    ],
    "bu’erci": [
        2253
    ],
    "bu’erzi": [
        2253
    ],
    "bu’erzi ersu": [
        2253
    ],
    "babiruwa": [
        2254
    ],
    "babrua": [
        2254
    ],
    "babruwa": [
        2254
    ],
    "baburiwa": [
        2254
    ],
    "bering strait": [
        2297,
        2298
    ],
    "bering": [
        2297,
        2298
    ],
    "bering strait yupik": [
        2297,
        2298
    ],
    "bisayan declarado": [
        2300,
        2301
    ],
    "bisayan": [
        2300,
        2301
    ],
    "bisayan diklaradu": [
        2300,
        2301
    ],
    "bisayan-eskaya": [
        2300,
        2301
    ],
    "barranquenho": [
        2324
    ],
    "barranquian": [
        2324
    ],
    "barranquênhu": [
        2324
    ],
    "baissa": [
        2336
    ],
    "baissa fali": [
        2336
    ],
    "benjube fenga": [
        2339
    ],
    "benjube": [
        2339
    ],
    "bikol, west albay": [
        2349
    ],
    "bèfɨràn": [
        2390
    ],
    "boumaa fijian": [
        2393
    ],
    "boumaa": [
        2393
    ],
    "bika": [
        2402
    ],
    "bafang": [
        2403
    ],
    "bamileke-fe’fe’": [
        2403
    ],
    "bantu": [
        2406
    ],
    "basic zulu": [
        2406
    ],
    "basic": [
        2406
    ],
    "baksa": [
        2415
    ],
    "bembi": [
        2417,
        6114
    ],
    "barang": [
        2418,
        2424,
        2434
    ],
    "bl": [
        2423
    ],
    "barthélemy": [
        2568,
        2423
    ],
    "biira": [
        2479,
        2480
    ],
    "boulbe": [
        2479,
        2480
    ],
    "benin-togo fulfulde": [
        2482
    ],
    "benin-togo": [
        2482
    ],
    "borgu fulfulde": [
        2482
    ],
    "baghirmi peul": [
        2489
    ],
    "bagirmi fula": [
        2489
    ],
    "bagirmi fulfulde": [
        2489
    ],
    "bagero": [
        2496
    ],
    "bagiro": [
        2496
    ],
    "baguero": [
        2496
    ],
    "baguiro": [
        2496
    ],
    "belé’ŋ": [
        2500
    ],
    "bèle fòòr": [
        2500
    ],
    "bèle": [
        2500
    ],
    "baniva de maroa": [
        2512
    ],
    "bundi": [
        2513
    ],
    "bore": [
        2518
    ],
    "borei": [
        2518
    ],
    "butelkud-guntabak": [
        2533
    ],
    "borana-arsi-guji": [
        2534,
        2535,
        2536,
        2537
    ],
    "borana": [
        2534,
        2535,
        2536
    ],
    "booran": [
        2534,
        2535
    ],
    "boraan": [
        2534,
        2535
    ],
    "boraana": [
        2534,
        2535
    ],
    "boran": [
        2534,
        2535
    ],
    "borana-arsi-guji oromo": [
        2534,
        2535
    ],
    "baya": [
        2539
    ],
    "banziri": [
        2545
    ],
    "bodo gadaba": [
        2548
    ],
    "boi gadaba": [
        2548
    ],
    "boi": [
        7319,
        2548,
        7877
    ],
    "bharmauri bhadi": [
        2549,
        2550
    ],
    "bharmauri": [
        2549,
        2550
    ],
    "bhadi": [
        2549,
        2550
    ],
    "brahmauri": [
        2549,
        2550
    ],
    "bosangoa": [
        2555
    ],
    "borro": [
        2555
    ],
    "bossangoa": [
        2555
    ],
    "bozom": [
        2556
    ],
    "bozoum": [
        2556
    ],
    "banu": [
        2560
    ],
    "bagri lohar": [
        2574
    ],
    "belani": [
        2574
    ],
    "bhubaliya lohar": [
        2574
    ],
    "bhubaliya": [
        2574
    ],
    "badhun": [
        2577
    ],
    "baliwon": [
        2581
    ],
    "berbère": [
        2627
    ],
    "bia": [
        2636,
        8936
    ],
    "bhotte": [
        2637
    ],
    "baynawa": [
        2641
    ],
    "britain": [
        2649,
        3957
    ],
    "bai gelo": [
        2655
    ],
    "bajania": [
        2659,
        2660
    ],
    "belning": [
        2675
    ],
    "balning": [
        2675
    ],
    "belnəng": [
        2675
    ],
    "bon gula": [
        2676
    ],
    "bon goula": [
        2676
    ],
    "brofo": [
        2754
    ],
    "barclayville": [
        2785
    ],
    "barclayville grebo": [
        2785
    ],
    "biapim": [
        2793
    ],
    "bugre": [
        2815,
        3633
    ],
    "bininj gun-wok": [
        2817
    ],
    "bininj": [
        2817
    ],
    "bashgharik": [
        2843
    ],
    "bashkarik": [
        2843
    ],
    "baskarik": [
        2843
    ],
    "bagwere": [
        2852
    ],
    "babinga": [
        2863,
        8365
    ],
    "bagiele": [
        2863
    ],
    "bagyele": [
        2863
    ],
    "bajele": [
        2863
    ],
    "bajeli": [
        2863
    ],
    "bako": [
        2863
    ],
    "bakola": [
        2863
    ],
    "bakuele": [
        2863
    ],
    "bekoe": [
        2863
    ],
    "bogyel": [
        2863
    ],
    "bogyeli": [
        2863
    ],
    "bondjiel": [
        2863
    ],
    "bagba": [
        2870
    ],
    "borai": [
        2885
    ],
    "bushman": [
        2928,
        2950,
        8052,
        8684
    ],
    "baat": [
        2940,
        2941,
        3781
    ],
    "bakhwa": [
        2950
    ],
    "basarwa": [
        2950
    ],
    "big flowery miao": [
        2973,
        2974,
        2975
    ],
    "big": [
        2973,
        2974,
        2975,
        3112,
        5562,
        7371,
        7573
    ],
    "binh": [
        2977
    ],
    "black miao": [
        2986,
        2989,
        2991
    ],
    "biantou miao": [
        2997,
        2998
    ],
    "biantou": [
        2997,
        2998
    ],
    "bahungu": [
        3002
    ],
    "blue hmong": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "blue": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "blue meo": [
        3008
    ],
    "bharatiya": [
        3013
    ],
    "bihar ho": [
        3019,
        3020,
        3021,
        3022,
        3023
    ],
    "bihar": [
        3019,
        3020,
        3021,
        3022,
        3023
    ],
    "bali holma": [
        3024
    ],
    "barom": [
        3025
    ],
    "bungan": [
        3036
    ],
    "baihong": [
        3037
    ],
    "bai miao": [
        3050,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "bahnar cham": [
        3051
    ],
    "bebaye": [
        3060
    ],
    "bahasa asli": [
        3074
    ],
    "bula’a": [
        3082
    ],
    "bhote": [
        3089,
        3986,
        7599
    ],
    "bue": [
        3090
    ],
    "balamata": [
        3092
    ],
    "bambaa": [
        3092
    ],
    "big sepik": [
        3112
    ],
    "bih": [
        3120
    ],
    "benguet-igorot": [
        3121
    ],
    "bambami": [
        3122
    ],
    "bambani": [
        3122
    ],
    "bonny": [
        3126
    ],
    "bahasa indonesia": [
        3131,
        3132,
        3133
    ],
    "batad": [
        3146
    ],
    "batad ifugao": [
        3146
    ],
    "baate": [
        3147,
        3148
    ],
    "balahaim": [
        3161
    ],
    "based": [
        3165,
        5936
    ],
    "bidhawal": [
        3168
    ],
    "black yi": [
        3169,
        3170,
        8949,
        8950
    ],
    "biseni": [
        3173
    ],
    "buseni": [
        3173
    ],
    "bibi": [
        3175
    ],
    "brass ijo": [
        3176
    ],
    "brass": [
        3176
    ],
    "brass-nembe": [
        3176
    ],
    "bekulu": [
        3181
    ],
    "bogkalot": [
        3196
    ],
    "bugkalot": [
        3196
    ],
    "bugkalut": [
        3196
    ],
    "bukalot": [
        3196
    ],
    "bangla ishara vasha": [
        3224
    ],
    "bangla sign language": [
        3224
    ],
    "bangladesh sign language": [
        3224
    ],
    "bangladeshi sign language": [
        3224
    ],
    "bangladeshi": [
        3224
    ],
    "bengali sign language": [
        3224
    ],
    "beduba": [
        3235
    ],
    "binongan": [
        3265
    ],
    "binongan itneg": [
        3265
    ],
    "betef": [
        3278
    ],
    "borto": [
        3278
    ],
    "ban yao": [
        3283,
        3284,
        3285,
        3286,
        3287,
        8898
    ],
    "banagere": [
        3297
    ],
    "bocas del toro patois": [
        3315
    ],
    "bocas": [
        3315,
        8240
    ],
    "bongo talk": [
        3315
    ],
    "bahasa melayu jambi": [
        3322
    ],
    "bahaso daerah": [
        3322
    ],
    "bahaso": [
        3322
    ],
    "bahaso dusun": [
        3322
    ],
    "baso jambi": [
        3322
    ],
    "baso": [
        3322,
        5133
    ],
    "batin": [
        3322
    ],
    "bulthun": [
        3323
    ],
    "badjiri": [
        3326
    ],
    "baddjeri": [
        3326
    ],
    "badjari": [
        3326
    ],
    "barikewa": [
        3328
    ],
    "bijim": [
        3329
    ],
    "bijimawa": [
        3329
    ],
    "berber": [
        6906,
        3330,
        6519,
        6520,
        6521,
        6522,
        6888,
        7884,
        7885,
        7886,
        9010,
        9011
    ],
    "bergalgu": [
        3335
    ],
    "bik": [
        3341,
        3342,
        3343
    ],
    "bourmataguil": [
        3354
    ],
    "bankalawa": [
        3358
    ],
    "bununu": [
        3358
    ],
    "bamileke-ngomba": [
        3359
    ],
    "bu (kaduna state)": [
        3365
    ],
    "buyuan": [
        3377
    ],
    "buyuan jinuo": [
        3377
    ],
    "bang-eon": [
        3378
    ],
    "bankal": [
        3379
    ],
    "bankala": [
        3379
    ],
    "bankalanci": [
        3379
    ],
    "baranci": [
        3379
    ],
    "bilichi": [
        3381
    ],
    "bayu dimadima": [
        3389
    ],
    "bayu": [
        3389,
        8064
    ],
    "bi-gimu": [
        3393
    ],
    "ban manus": [
        3406
    ],
    "ban rauts": [
        3406
    ],
    "bhulla": [
        3406
    ],
    "bãt-kha": [
        3406
    ],
    "bakokan": [
        3429
    ],
    "boanawari": [
        3431
    ],
    "burra burra": [
        3431
    ],
    "berin": [
        3434
    ],
    "bajibaro": [
        3436
    ],
    "bajju": [
        3468
    ],
    "baju": [
        3468
    ],
    "bezhta": [
        3472
    ],
    "bazht’": [
        3472
    ],
    "bazht’al": [
        3472
    ],
    "bechitin": [
        3472
    ],
    "bexita": [
        3472
    ],
    "bezheta": [
        3472
    ],
    "bezhita": [
        3472
    ],
    "bezhituri": [
        3472
    ],
    "bezhti": [
        3472
    ],
    "bezhtin": [
        3472
    ],
    "bezht’alas mits": [
        3472
    ],
    "bezht’alas": [
        3472
    ],
    "baquebo": [
        3473
    ],
    "biá": [
        8936,
        3474
    ],
    "botin": [
        3502
    ],
    "buy": [
        3515
    ],
    "bakaa": [
        3516
    ],
    "bwari": [
        3528
    ],
    "belbalis": [
        3530
    ],
    "birbay": [
        3532
    ],
    "banjangi": [
        3571
    ],
    "banyang": [
        3571
    ],
    "banyangi": [
        3571
    ],
    "bayangi": [
        3571
    ],
    "bari kakwa": [
        3572
    ],
    "bakele": [
        3585
    ],
    "bondeya": [
        3608
    ],
    "bopchi": [
        3608
    ],
    "bilaspuri": [
        3611
    ],
    "bilaspuri pahari": [
        3611
    ],
    "bhat": [
        3612
    ],
    "baanbay": [
        3636
    ],
    "bädi": [
        3648
    ],
    "bedi ngkolmpu": [
        3648
    ],
    "bedi": [
        3648
    ],
    "bädi kanum": [
        3648
    ],
    "bejube ko": [
        3674
    ],
    "bejube": [
        3674
    ],
    "benubcouh": [
        3674
    ],
    "bahasa meher": [
        3700
    ],
    "bren": [
        3710
    ],
    "bumthangkha": [
        3727
    ],
    "bhumtam": [
        3727
    ],
    "bumtang": [
        3727
    ],
    "bumtangkha": [
        3727
    ],
    "bumtanp": [
        3727
    ],
    "bumthang": [
        3727
    ],
    "bumthapkha": [
        3727
    ],
    "berang": [
        3752
    ],
    "bu giiwo": [
        3755
    ],
    "ba’a": [
        3756
    ],
    "bahasa seruyan": [
        3760
    ],
    "bra": [
        3781
    ],
    "braa": [
        3781
    ],
    "bakole": [
        3797
    ],
    "bakolle": [
        3797
    ],
    "bamusso": [
        3797
    ],
    "banglori": [
        3818,
        3819,
        3820
    ],
    "bankoti": [
        3832,
        3833,
        3861
    ],
    "belubn": [
        3838,
        3839
    ],
    "badameà": [
        3844
    ],
    "baicit": [
        3844
    ],
    "bakonzo": [
        3863
    ],
    "bayira": [
        3863,
        5592
    ],
    "baniva del isana": [
        3875
    ],
    "baniva-kurripako": [
        3875
    ],
    "baniwa del isana": [
        3875
    ],
    "bambadion-kheso": [
        3904
    ],
    "balaŋ": [
        3909
    ],
    "birang": [
        3909
    ],
    "botocudo": [
        3914
    ],
    "botocudos": [
        3914,
        8579
    ],
    "borno": [
        3925,
        3926
    ],
    "bornouan": [
        3925,
        3926
    ],
    "bornouans": [
        3925,
        3926
    ],
    "bornu": [
        3925,
        3926
    ],
    "balkar": [
        3929
    ],
    "balkarian": [
        3929
    ],
    "balqar": [
        3929
    ],
    "bagwama": [
        3933,
        6634
    ],
    "binisaya nga karay-a": [
        3935
    ],
    "bisaya nga kinaray-a": [
        3935
    ],
    "brao krung": [
        3941
    ],
    "blanche bay": [
        3957
    ],
    "blanche": [
        3957
    ],
    "bafia": [
        3959
    ],
    "bekpak": [
        3959
    ],
    "baibokoum": [
        3969
    ],
    "borong": [
        3971
    ],
    "boroŋ": [
        3971
    ],
    "burmese karen": [
        3976,
        3977
    ],
    "burmese": [
        5231,
        5232,
        5831,
        3976,
        3977,
        6845,
        6846,
        6847,
        6848,
        8907
    ],
    "batem-da-kai-ee": [
        4003
    ],
    "bas-uélé": [
        4005
    ],
    "badinani": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "badînî": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "bahdini": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "behdînî": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "boye": [
        4025
    ],
    "baada": [
        4029
    ],
    "baaden": [
        4029
    ],
    "baaza": [
        4029
    ],
    "baazayn": [
        4029
    ],
    "baazen": [
        4029
    ],
    "baden": [
        4029
    ],
    "bazen": [
        4029
    ],
    "bagadji": [
        4039
    ],
    "bagvalal": [
        4045
    ],
    "bagulal": [
        4045
    ],
    "bagvalin": [
        4045
    ],
    "bagwalal": [
        4045
    ],
    "barbalin": [
        4045
    ],
    "boadji": [
        4051
    ],
    "boazi": [
        4051
    ],
    "bwadji": [
        4051
    ],
    "bokwa-kendem": [
        4057
    ],
    "border": [
        4058
    ],
    "border kuna": [
        4058
    ],
    "baa": [
        4074
    ],
    "báà": [
        4074
    ],
    "bakoum": [
        4092
    ],
    "bakum": [
        4092
    ],
    "bakoroka": [
        4097
    ],
    "brunai": [
        4102,
        4103
    ],
    "brunei-kadayan": [
        4102,
        4103
    ],
    "barkari": [
        4118
    ],
    "butbut": [
        4133
    ],
    "butbut kalinga": [
        4133
    ],
    "baiyer": [
        4134
    ],
    "binukidnon, northern": [
        4145
    ],
    "binukidnon": [
        4145,
        5123
    ],
    "baram kajan": [
        4150
    ],
    "baram kayan": [
        4150
    ],
    "bedia": [
        4156,
        4157,
        4158,
        7382,
        7383,
        7384
    ],
    "bondoukou": [
        4164
    ],
    "bondoukou kulango": [
        4164
    ],
    "bonduku": [
        4164
    ],
    "basa da’a": [
        4167
    ],
    "binggi": [
        4167
    ],
    "bunggu": [
        4167
    ],
    "bakanike": [
        4174
    ],
    "bakaningi": [
        4174
    ],
    "bolangitang": [
        4175
    ],
    "bakal": [
        4177
    ],
    "beraur": [
        4184
    ],
    "bendi lolo": [
        4208
    ],
    "bao": [
        4208
    ],
    "beo": [
        4208
    ],
    "bai, lama": [
        4215
    ],
    "bhotia of lahul": [
        4222,
        4223
    ],
    "bikol, libon": [
        4227
    ],
    "boloven": [
        4231
    ],
    "boriwen": [
        4231
    ],
    "barito": [
        4239,
        5476
    ],
    "biza-lala": [
        4267
    ],
    "bbaledha": [
        4269
    ],
    "baledha": [
        4269
    ],
    "balendru": [
        4269
    ],
    "baletha": [
        4269
    ],
    "batha": [
        4269
    ],
    "bbadha": [
        4269
    ],
    "buem": [
        4271
    ],
    "bashilele": [
        4276
    ],
    "balese": [
        4284
    ],
    "baebunta": [
        4290
    ],
    "balom": [
        4293
    ],
    "baganda": [
        4296,
        4297
    ],
    "bushman’s bay": [
        4304
    ],
    "bushman’s": [
        4304
    ],
    "black lahu": [
        4322
    ],
    "bli": [
        4326
    ],
    "balobo": [
        4328
    ],
    "bangela": [
        4328
    ],
    "bosele": [
        4338
    ],
    "banda-bambari": [
        4347
    ],
    "banda of bambari": [
        4347
    ],
    "bambari": [
        4347
    ],
    "banda-linda": [
        4347
    ],
    "binza": [
        4348,
        9056
    ],
    "barang-barang": [
        4351
    ],
    "bakenyi": [
        4361
    ],
    "berri": [
        4369,
        8975,
        8976,
        8977
    ],
    "bwatvenua": [
        4405
    ],
    "banjari": [
        4406,
        4407,
        4408
    ],
    "banjori": [
        4406,
        4407,
        4408
    ],
    "banjuri": [
        4406,
        4407,
        4408
    ],
    "brinjari": [
        4406,
        4407,
        4408
    ],
    "bojiin": [
        4410
    ],
    "buri tau": [
        4425
    ],
    "buri": [
        4425
    ],
    "buri’ lun bawang": [
        4425
    ],
    "buri’": [
        4425
    ],
    "buri’ lun dayeh": [
        4425
    ],
    "banda, south central": [
        4431
    ],
    "bansaw": [
        4435
    ],
    "banso": [
        4435
    ],
    "banso’": [
        4435
    ],
    "bisaya-inunhan": [
        4442
    ],
    "boya": [
        4446
    ],
    "baluan-lou-pam": [
        4448
    ],
    "bakati’, rara": [
        4474
    ],
    "bekatiq": [
        4474
    ],
    "bekati’ kendayan": [
        4474
    ],
    "bekati’": [
        4474
    ],
    "bekati’ nyam-pelayo": [
        4474
    ],
    "bahasa nagi": [
        4486
    ],
    "bek": [
        4488
    ],
    "burundian sign language": [
        4490
    ],
    "burundian": [
        4490
    ],
    "burundaise": [
        4490
    ],
    "bagwe": [
        4497
    ],
    "basamia": [
        4497
    ],
    "bod kyi lag brda": [
        4498
    ],
    "brda": [
        4498
    ],
    "bökyi lagda": [
        4498
    ],
    "bökyi": [
        4498
    ],
    "batsotso": [
        4514
    ],
    "bena-lulua": [
        4518
    ],
    "balovale": [
        4521
    ],
    "baloumbou": [
        4530
    ],
    "babukusu": [
        4540
    ],
    "bukusu": [
        4540
    ],
    "basa mathura": [
        4573
    ],
    "bo-rukul": [
        4574
    ],
    "bulahai": [
        4575,
        4719
    ],
    "bihari": [
        4576,
        4577,
        4578,
        4579,
        4580,
        7987,
        7988,
        7991
    ],
    "basa mangkasara’": [
        4582,
        4583,
        4584
    ],
    "b'anax mam": [
        4585
    ],
    "banax": [
        4585
    ],
    "b’anax mam": [
        4585
    ],
    "b’anax": [
        4585
    ],
    "bot’una": [
        4593
    ],
    "bahasa pasar": [
        4598
    ],
    "baba malay": [
        4605
    ],
    "baga foré": [
        4620
    ],
    "baga monson": [
        4620
    ],
    "black baga": [
        4620
    ],
    "bulunits": [
        4620
    ],
    "bitur": [
        4627
    ],
    "bituri": [
        4627
    ],
    "bahasa geragau": [
        4637
    ],
    "bahasa serani": [
        4637
    ],
    "biparé": [
        4643
    ],
    "bà": [
        4645
    ],
    "bang": [
        4645,
        5266
    ],
    "ble": [
        4645
    ],
    "bimu": [
        4648
    ],
    "bargo": [
        4655,
        4656
    ],
    "bergo": [
        4655,
        4656
    ],
    "borgho": [
        4655,
        4656
    ],
    "bura mabang": [
        4655,
        4656
    ],
    "bando": [
        4680
    ],
    "belana’u": [
        4690
    ],
    "boumpe": [
        4692,
        4693
    ],
    "bithan": [
        4704,
        4705
    ],
    "bangka": [
        4709
    ],
    "bunaki": [
        4713
    ],
    "balda": [
        4716
    ],
    "baitsawara": [
        4719
    ],
    "boulahay": [
        4719
    ],
    "berringen": [
        4727
    ],
    "barga": [
        4735
    ],
    "borizano": [
        4736,
        4738
    ],
    "borizany": [
        4736,
        4738
    ],
    "bombo": [
        4746
    ],
    "bameta": [
        4754
    ],
    "batibo": [
        4754
    ],
    "bamalila": [
        4757
    ],
    "bunga": [
        4764
    ],
    "buwe": [
        4765
    ],
    "besisi": [
        4771
    ],
    "btsisi’": [
        4771
    ],
    "betisek": [
        4771
    ],
    "balinese malay": [
        4781
    ],
    "boeroe": [
        4783
    ],
    "buru (indonesia)": [
        4783
    ],
    "buruese": [
        4783
    ],
    "bravo": [
        4812
    ],
    "basha": [
        4832
    ],
    "bere": [
        4847
    ],
    "bre": [
        4847
    ],
    "bɛrɛ": [
        4847
    ],
    "byep": [
        4856
    ],
    "basa kupang": [
        4859
    ],
    "bay miwok": [
        4862
    ],
    "bargam": [
        4889
    ],
    "buang, mangga": [
        4915
    ],
    "bonga": [
        4919
    ],
    "baniva de rio içana": [
        4921
    ],
    "baníwa do içana": [
        4921
    ],
    "baníwa": [
        4921
    ],
    "buia-tapuya": [
        4921
    ],
    "búia-tapúya": [
        4921
    ],
    "bolaang mongondow": [
        4964
    ],
    "bolang-mogondo": [
        4964
    ],
    "bonom": [
        4970
    ],
    "bomberai": [
        4972
    ],
    "barí": [
        4976
    ],
    "baria": [
        4976,
        7770,
        7815
    ],
    "barira": [
        4976
    ],
    "bicoli": [
        5010
    ],
    "bitjoli": [
        5010
    ],
    "bangun": [
        5015
    ],
    "bebelibe": [
        5020
    ],
    "bèbèdibè": [
        5020
    ],
    "bahasa malaysia": [
        5067,
        5068,
        5070
    ],
    "bahasa malayu": [
        5067,
        5068,
        5070
    ],
    "bahasa melayu malaysia": [
        5067,
        5068,
        5070
    ],
    "baku": [
        5067,
        5068,
        5070
    ],
    "bananna": [
        5077
    ],
    "bananna ho": [
        5077
    ],
    "bananna ho ho": [
        5077
    ],
    "bahasa sabah": [
        5081
    ],
    "bazaar malay": [
        5081
    ],
    "bazaar": [
        5081
    ],
    "baltap": [
        5112
    ],
    "binukidnon, southern": [
        5123
    ],
    "baso palembang": [
        5133
    ],
    "beir": [
        5140,
        5141
    ],
    "bo-ung": [
        5146
    ],
    "bartolomé": [
        5157,
        7888,
        7889,
        7890,
        7891,
        9136
    ],
    "bargal": [
        5161
    ],
    "basing": [
        5193,
        5194
    ],
    "banded arm hmong": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "banded": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "bamanyeka": [
        5207
    ],
    "bambuba": [
        5212
    ],
    "bamvuba": [
        5212
    ],
    "baja": [
        7303,
        5224
    ],
    "bama": [
        5231,
        5232,
        5440,
        6845,
        6846,
        6847,
        6848
    ],
    "bama saka": [
        5231,
        5232
    ],
    "bamachaka": [
        5231,
        5232
    ],
    "banta": [
        5237
    ],
    "bantakpa": [
        5237
    ],
    "bug": [
        5240
    ],
    "buga": [
        5240
    ],
    "bamaraga": [
        5241
    ],
    "bagisu": [
        5252
    ],
    "baigana": [
        5253
    ],
    "buhagana": [
        5253
    ],
    "berg-tomori": [
        5272
    ],
    "boven-mori": [
        5272
    ],
    "buro": [
        5278
    ],
    "banlamgi": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "banlamgu": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "banlamue": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "bân-lâm-gú": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "bergdamara": [
        5300
    ],
    "bokmål": [
        5308,
        5309
    ],
    "bangbinda": [
        5313
    ],
    "bungbinda": [
        5313
    ],
    "bouaka": [
        5320
    ],
    "bwaka": [
        5320
    ],
    "bafuchu": [
        5330
    ],
    "banja": [
        5330,
        9106
    ],
    "bangdale": [
        5337
    ],
    "bangdel tûm": [
        5337
    ],
    "bangdel": [
        5337
    ],
    "bangdile": [
        5337
    ],
    "bhra": [
        5337
    ],
    "bamessing": [
        5360
    ],
    "befi": [
        5360
    ],
    "bondonga": [
        5377
    ],
    "balungada": [
        5391
    ],
    "biti": [
        5392
    ],
    "bötö": [
        5392
    ],
    "beye": [
        5395
    ],
    "bhotea of upper kinnauri": [
        5405
    ],
    "bhotea": [
        5405
    ],
    "bhoti kinnauri": [
        5405
    ],
    "bod-skad": [
        5405
    ],
    "bud-kat": [
        5405
    ],
    "bhaye": [
        5409,
        5410,
        5411
    ],
    "bhaae": [
        5409,
        5410,
        5411
    ],
    "bhaaye": [
        5409,
        5410,
        5411
    ],
    "banafo": [
        5418
    ],
    "bagandou": [
        5424
    ],
    "bangandou": [
        5424
    ],
    "bodzanga": [
        5424
    ],
    "ba-ndom": [
        5425
    ],
    "baminge": [
        5429
    ],
    "baninge": [
        5429
    ],
    "bouin": [
        5430
    ],
    "boun": [
        5430
    ],
    "buan": [
        5430
    ],
    "buwan": [
        5430
    ],
    "beng": [
        5446
    ],
    "biadju": [
        5476
    ],
    "bindi": [
        5491
    ],
    "borduria": [
        5494
    ],
    "bege": [
        5499
    ],
    "begi": [
        5499
    ],
    "bonefa": [
        5504
    ],
    "badonjunga": [
        5506
    ],
    "bardojunga": [
        5506
    ],
    "bangni": [
        5509,
        5510
    ],
    "bouna": [
        5531
    ],
    "bouna koulango": [
        5531
    ],
    "bouna kulango": [
        5531
    ],
    "buna kulango": [
        5531
    ],
    "bankutu": [
        5533
    ],
    "bq": [
        5539
    ],
    "bonaire, sint eustatius and saba": [
        5539
    ],
    "bonaire": [
        5539
    ],
    "bamileke-ngombale": [
        5544
    ],
    "banyala": [
        5546
    ],
    "boogoolmurra": [
        5557
    ],
    "bugulmara": [
        5557
    ],
    "big nambas": [
        5562
    ],
    "bandoumou": [
        5564
    ],
    "bujeba": [
        5567,
        5568
    ],
    "bagando-ngombe": [
        5571
    ],
    "bangando-ngombe": [
        5571
    ],
    "bandem": [
        5573
    ],
    "bayong": [
        5573
    ],
    "bujuurchong": [
        5577,
        5578
    ],
    "banyai": [
        5580
    ],
    "banande": [
        5592
    ],
    "bamileke-ngiemboon": [
        5599
    ],
    "bamileke-ngyemboon": [
        5599
    ],
    "banpara naga": [
        5606,
        5607,
        5608
    ],
    "banpara": [
        5606,
        5607,
        5608
    ],
    "bamileke-nda’nda’": [
        5616
    ],
    "bangwa": [
        5616
    ],
    "bhilori": [
        8059,
        8060,
        5626
    ],
    "boana": [
        5632
    ],
    "bangom": [
        5663
    ],
    "bangomo": [
        5663
    ],
    "black lolo": [
        5723
    ],
    "bu-nong": [
        5745
    ],
    "bizaad": [
        5752
    ],
    "bamileke-ngwe": [
        5763
    ],
    "bongando": [
        5772
    ],
    "badjava": [
        5774
    ],
    "bajava": [
        5774
    ],
    "bajawa": [
        5774
    ],
    "banyole": [
        5790
    ],
    "banyore": [
        5790
    ],
    "biyabanak": [
        5803
    ],
    "bandzabi": [
        5813
    ],
    "binzabi": [
        5813
    ],
    "bontok, southern": [
        5827
    ],
    "bukuma": [
        5853
    ],
    "babangk": [
        5876
    ],
    "bvukoo": [
        5887
    ],
    "black mountain language": [
        5893
    ],
    "bê": [
        5921
    ],
    "bootpa": [
        5929,
        5930
    ],
    "but monpa": [
        5929,
        5930
    ],
    "but pa": [
        5929,
        5930
    ],
    "bailala": [
        5956
    ],
    "baraki": [
        5960
    ],
    "baraks": [
        5960
    ],
    "bargista": [
        5960
    ],
    "berki": [
        5960
    ],
    "birki": [
        5960
    ],
    "brakee": [
        5960
    ],
    "braki": [
        5960
    ],
    "burki": [
        5960
    ],
    "banyuwangi": [
        5973
    ],
    "bero": [
        6005
    ],
    "bo river van kieu": [
        6017,
        6018,
        6019
    ],
    "belauan": [
        6037
    ],
    "belau": [
        6037
    ],
    "badyara": [
        6054
    ],
    "badara": [
        6054
    ],
    "badian": [
        6054
    ],
    "badjara": [
        6054
    ],
    "badjaranké": [
        6054
    ],
    "badyaranke": [
        6054
    ],
    "badyaranké": [
        6054
    ],
    "bajara": [
        6054
    ],
    "bigola": [
        6054
    ],
    "bouyei": [
        6062,
        6063
    ],
    "bo-i": [
        6062,
        6063
    ],
    "bo-y": [
        6062,
        6063
    ],
    "bui": [
        6062,
        6063,
        9146,
        9147
    ],
    "buyei": [
        6062,
        6063,
        9016
    ],
    "buyui": [
        6062,
        6063
    ],
    "bulai": [
        6065
    ],
    "bulei": [
        6065
    ],
    "bahelia": [
        6076
    ],
    "brokin": [
        6077
    ],
    "brokun": [
        6077
    ],
    "bisi": [
        6078
    ],
    "baba indonesian": [
        6089
    ],
    "bonan": [
        6095
    ],
    "baonan": [
        6095
    ],
    "bao’an": [
        6095
    ],
    "boan": [
        6095
    ],
    "bc": [
        6101
    ],
    "baheng": [
        6121
    ],
    "bahengmai": [
        6121
    ],
    "biyori": [
        6126
    ],
    "bana’": [
        6130
    ],
    "bandjanu": [
        6150
    ],
    "banjanu": [
        6150
    ],
    "biniridjara": [
        6150
    ],
    "birni": [
        6150
    ],
    "birniridjara": [
        6150
    ],
    "buranudjara": [
        6150
    ],
    "bida-bida": [
        6159
    ],
    "bidhabidha": [
        6159
    ],
    "bindabu": [
        6160
    ],
    "binddibu": [
        6160
    ],
    "bindibu": [
        6160
    ],
    "bindubi": [
        6160
    ],
    "bindubu": [
        6160
    ],
    "bakanha": [
        6173
    ],
    "bukabukan": [
        6175
    ],
    "bakau": [
        6179
    ],
    "bonaputa-mopu": [
        6182
    ],
    "brooke’s": [
        6200
    ],
    "brooke's point palawano": [
        6200
    ],
    "brookes": [
        6200
    ],
    "brooke’s point palawan": [
        6200
    ],
    "bolyu": [
        6201
    ],
    "baliu": [
        6201
    ],
    "buliu": [
        6201,
        6291
    ],
    "balangamida": [
        6205
    ],
    "baree": [
        6207
    ],
    "bare’e": [
        6207
    ],
    "bahasa tanah": [
        6222
    ],
    "bah-biau": [
        6224
    ],
    "bah-biau penan": [
        6224
    ],
    "bangoula": [
        6231
    ],
    "banyoula": [
        6231
    ],
    "banyowla": [
        6231
    ],
    "bindjarub": [
        6231
    ],
    "binjarup": [
        6231
    ],
    "bunu, jiongnai": [
        6244
    ],
    "binigura": [
        6245
    ],
    "banyjima": [
        6246
    ],
    "bandjima": [
        6246
    ],
    "banjima": [
        6246
    ],
    "bapinyi": [
        6248
    ],
    "bara sona": [
        6256
    ],
    "barasana": [
        6256
    ],
    "bará": [
        6256
    ],
    "bará-tukano": [
        6256
    ],
    "ballo-kai-pomo": [
        6259
    ],
    "bode’wadmi": [
        6263
    ],
    "baiyamo": [
        6268
    ],
    "bupuran": [
        6279
    ],
    "barao": [
        6291
    ],
    "baraog": [
        6291
    ],
    "baraoke": [
        6291
    ],
    "baroke": [
        6291
    ],
    "burao": [
        6291
    ],
    "burig": [
        6303,
        6304
    ],
    "burigskat": [
        6303,
        6304
    ],
    "bengkulu": [
        6311
    ],
    "besemah": [
        6311
    ],
    "buré": [
        6345
    ],
    "bambam": [
        6350
    ],
    "basa bambam": [
        6350
    ],
    "buguli": [
        6360
    ],
    "buguri": [
        6360
    ],
    "burubora": [
        6368
    ],
    "bkwala": [
        6372
    ],
    "bugel": [
        6375
    ],
    "bujiye": [
        6375
    ],
    "balabak": [
        6378
    ],
    "butanglu": [
        6379
    ],
    "bassein pwo karen": [
        6380
    ],
    "bassein": [
        6380
    ],
    "beinan": [
        6388,
        6389
    ],
    "biˎ suˎ": [
        6391
    ],
    "biˎ": [
        6391
    ],
    "bara naga": [
        6392
    ],
    "boliviano": [
        6394
    ],
    "bobonaza": [
        6429
    ],
    "bobonaza quichua": [
        6429
    ],
    "bohuai": [
        6465
    ],
    "bohuai-tulu": [
        6465
    ],
    "bowai": [
        6465
    ],
    "boto boli": [
        6475
    ],
    "boto": [
        6475
    ],
    "bontok, northern": [
        6487
    ],
    "bikol, miraya": [
        6488
    ],
    "barababaraba": [
        6489
    ],
    "baraba baraba": [
        6489
    ],
    "baraba": [
        6489
    ],
    "baraba-baraba": [
        6489
    ],
    "baraparapa": [
        6489
    ],
    "barappur": [
        6489
    ],
    "bareber bareber": [
        6489
    ],
    "bareber": [
        6489
    ],
    "barraba-barraba": [
        6489
    ],
    "barrababarraba": [
        6489
    ],
    "beraba-beraba": [
        6489
    ],
    "birraba-birraba": [
        6489
    ],
    "boora-boora": [
        6489
    ],
    "boorabirraba": [
        6489
    ],
    "booraboora": [
        6489
    ],
    "boort": [
        6489
    ],
    "burabura": [
        6489
    ],
    "burappa": [
        6489
    ],
    "burapper": [
        6489
    ],
    "bureba": [
        6489
    ],
    "burrabura-ba": [
        6489
    ],
    "burraburburaba": [
        6489
    ],
    "burrappa": [
        6489
    ],
    "burrapper": [
        6489
    ],
    "burreba-burreba": [
        6489
    ],
    "bareshe": [
        6503
    ],
    "borjano": [
        6505
    ],
    "black riang": [
        6523
    ],
    "black yang": [
        6523
    ],
    "ban raji": [
        6530
    ],
    "bhaasaa": [
        6530
    ],
    "bahe bangla": [
        6537
    ],
    "bahe": [
        6537
    ],
    "bashaldo": [
        6542
    ],
    "burgenland romani": [
        6542
    ],
    "bosa": [
        6548
    ],
    "bosha": [
        6548
    ],
    "boša": [
        6548
    ],
    "baltic": [
        6550,
        6551
    ],
    "balt romani": [
        6550,
        6551
    ],
    "balt": [
        6550,
        6551
    ],
    "balt slavic romani": [
        6550,
        6551
    ],
    "baltic romani": [
        6550,
        6551
    ],
    "baltic slavic romani": [
        6550,
        6551
    ],
    "balkan romani": [
        6553,
        6554,
        6555
    ],
    "barake": [
        6560
    ],
    "burogo": [
        6583
    ],
    "basi": [
        6587
    ],
    "beás": [
        6588,
        6590
    ],
    "bentenan": [
        6606
    ],
    "bal-la": [
        6609
    ],
    "baruli": [
        6618
    ],
    "bace": [
        6625
    ],
    "bache": [
        6625
    ],
    "bafumbira": [
        6635,
        6636
    ],
    "banyarwanda": [
        6635,
        6636
    ],
    "baamba": [
        6640
    ],
    "bulebule": [
        6640
    ],
    "boonara": [
        6644
    ],
    "bunara": [
        6644
    ],
    "buruwatung": [
        6644
    ],
    "buglere": [
        6659
    ],
    "bobota": [
        6659
    ],
    "bofota": [
        6659
    ],
    "bugle": [
        6659
    ],
    "burkeneji": [
        6672
    ],
    "botolan": [
        6702
    ],
    "botolan sambal": [
        6702
    ],
    "botolan zambal": [
        6702
    ],
    "braid scots": [
        6731
    ],
    "braid": [
        6731
    ],
    "basa toraya": [
        6747
    ],
    "basa tora’a": [
        6747
    ],
    "bidayuh serian": [
        6759
    ],
    "bidayuh, bukar-sadong": [
        6759
    ],
    "bukar-sadong": [
        6759
    ],
    "bidayŭh bukar-sadung": [
        6759
    ],
    "bidayŭh": [
        6759
    ],
    "bukar-sadung": [
        6759
    ],
    "buka": [
        6759
    ],
    "bukar": [
        6759
    ],
    "bukar sadong": [
        6759
    ],
    "bukar sadung bidayah": [
        6759
    ],
    "bidayah": [
        6759
    ],
    "bukar-sadong bidayuh": [
        6759
    ],
    "bukar-sadung bidayuh": [
        6759
    ],
    "buyaka": [
        6793
    ],
    "belgian": [
        6799
    ],
    "belge": [
        6799
    ],
    "belgique": [
        6799
    ],
    "baghap": [
        6815
    ],
    "buxia": [
        6817
    ],
    "brokpake": [
        6823
    ],
    "bol": [
        6833
    ],
    "burmese shan": [
        6845,
        6846,
        6847,
        6848
    ],
    "babino": [
        6866
    ],
    "babinsk": [
        6866
    ],
    "bhutia": [
        6879
    ],
    "bognak-asungorung": [
        6893
    ],
    "bajau kagayan": [
        6896
    ],
    "barbarya": [
        6906
    ],
    "baravet": [
        6916
    ],
    "bwaravet": [
        6916
    ],
    "banuah": [
        6919
    ],
    "belochki": [
        6927,
        6928,
        6929,
        6930
    ],
    "bolinao": [
        6971
    ],
    "binobolinao": [
        6971
    ],
    "bino-bolinao": [
        6971
    ],
    "binubolinao": [
        6971
    ],
    "binubulinao": [
        6971
    ],
    "boliano": [
        6971
    ],
    "bolinao sambal": [
        6971
    ],
    "bolinao zambal": [
        6971
    ],
    "bulinaw": [
        6971
    ],
    "bajau pela’u": [
        6972
    ],
    "bano": [
        6979
    ],
    "bidayuh, bau": [
        6993
    ],
    "bau bidayuh": [
        6993
    ],
    "bau-jagoi": [
        6993
    ],
    "baicoca": [
        7004
    ],
    "bain": [
        7004
    ],
    "braow": [
        7012
    ],
    "binja": [
        7027
    ],
    "bijobe": [
        7047
    ],
    "biyobe": [
        7047
    ],
    "batem": [
        7048
    ],
    "bakati’, sara": [
        7105
    ],
    "bikol sorsogon": [
        7121
    ],
    "balangingih": [
        7132,
        7133
    ],
    "baangingi’": [
        7132,
        7133
    ],
    "balagnini": [
        7132,
        7133
    ],
    "balangingi": [
        7132,
        7133
    ],
    "balangingi bajau": [
        7132,
        7133
    ],
    "balanguingui": [
        7132,
        7133
    ],
    "balanian": [
        7132,
        7133
    ],
    "balanini": [
        7132,
        7133
    ],
    "balignini": [
        7132,
        7133
    ],
    "bangingi": [
        7132,
        7133
    ],
    "bangingih": [
        7132,
        7133
    ],
    "bangingih sama": [
        7132,
        7133
    ],
    "baangingi": [
        7132,
        7133
    ],
    "bhilki": [
        7137
    ],
    "busillu sisala": [
        7140
    ],
    "busillu": [
        7140
    ],
    "bog latin": [
        7164
    ],
    "bog": [
        7164
    ],
    "bulo": [
        7165,
        7166
    ],
    "budíp": [
        7165
    ],
    "bulo stieng": [
        7165,
        7166
    ],
    "budeh": [
        7177
    ],
    "budeh stieng": [
        7177
    ],
    "basa sunda": [
        7183,
        7185,
        7186,
        7184
    ],
    "basa gumung": [
        7183,
        7184,
        7185,
        7186
    ],
    "bouni": [
        7195
    ],
    "bouni-bobe": [
        7195
    ],
    "bhujuwar": [
        7208
    ],
    "basili": [
        7232
    ],
    "basiri": [
        7232
    ],
    "bone": [
        7248
    ],
    "bunda": [
        7248
    ],
    "bune": [
        7248
    ],
    "bengali of cachar": [
        7271,
        7272,
        7273
    ],
    "bedouin": [
        7281
    ],
    "bedouin sign language": [
        7281
    ],
    "bimbia": [
        7293
    ],
    "baja tarahumara": [
        7303
    ],
    "botel tabago": [
        7314
    ],
    "botel": [
        7314
    ],
    "botel tobago": [
        7314
    ],
    "boy": [
        7319
    ],
    "bonotsek": [
        7324,
        7325,
        7326
    ],
    "barro": [
        7342
    ],
    "barro negro tunebo": [
        7342
    ],
    "bok": [
        7344
    ],
    "bataba": [
        7354
    ],
    "batammarab": [
        7354
    ],
    "big thap": [
        7371
    ],
    "blaik": [
        7371
    ],
    "blaiman": [
        7371
    ],
    "balleza": [
        7373
    ],
    "bediya": [
        7382,
        7383,
        7384
    ],
    "baraik": [
        7382,
        7383,
        7384
    ],
    "barik": [
        7382,
        7383,
        7384
    ],
    "balaban": [
        7406
    ],
    "bakedi": [
        7421
    ],
    "bakidi": [
        7421
    ],
    "belo": [
        7427
    ],
    "belu": [
        7427
    ],
    "botó": [
        7463
    ],
    "bangkok thai": [
        7468,
        7469
    ],
    "bangkok": [
        7468,
        7469
    ],
    "behran": [
        7470
    ],
    "barhagaule": [
        7483
    ],
    "blama": [
        7504
    ],
    "bamar": [
        7524
    ],
    "buksa": [
        7537
    ],
    "bhoksha": [
        7537
    ],
    "bhuksa": [
        7537
    ],
    "bukas": [
        7537
    ],
    "buxa": [
        7537
    ],
    "bwissi": [
        7570
    ],
    "big bay": [
        7573
    ],
    "bulang-su": [
        7577
    ],
    "bə̀g ɗə təmàgə́ə̀n": [
        7589
    ],
    "bə̀g": [
        7589
    ],
    "buzu": [
        7594,
        7595,
        7596
    ],
    "babylonian": [
        7605
    ],
    "babylonian talmudic aramaic": [
        7605
    ],
    "benua": [
        7610
    ],
    "bechuana": [
        7613
    ],
    "beetjuans": [
        7613
    ],
    "blancas": [
        7616
    ],
    "basari du bandemba": [
        7629
    ],
    "bandemba": [
        7629
    ],
    "bedik": [
        7629
    ],
    "budik": [
        7629
    ],
    "bitonga": [
        7644
    ],
    "batonga": [
        7645
    ],
    "banda, togbo-vara": [
        7652
    ],
    "borok": [
        7714,
        7715,
        7662,
        7663
    ],
    "baniata": [
        7692
    ],
    "bu-hwan": [
        7722
    ],
    "bidayuh, tringgus-sembaan": [
        7724
    ],
    "batsangui": [
        7729
    ],
    "bahasa sūg": [
        7734,
        7735
    ],
    "b'a'aj": [
        7757
    ],
    "b’a’aj": [
        7757
    ],
    "bwanabwana": [
        7759
    ],
    "bonek": [
        7760
    ],
    "belala": [
        7770
    ],
    "borá-tuyuka": [
        7787
    ],
    "betaya": [
        7796
    ],
    "betoya": [
        7796
    ],
    "betoye": [
        7796
    ],
    "bume": [
        7800
    ],
    "banen": [
        7814
    ],
    "banend": [
        7814
    ],
    "bidau creole portuguese": [
        7817
    ],
    "bidau": [
        7817
    ],
    "batangan taubuid": [
        7819
    ],
    "bai dai": [
        7825,
        7826
    ],
    "blanc": [
        7825,
        7826
    ],
    "brahmi": [
        7828
    ],
    "buruomiba": [
        7828
    ],
    "b": [
        7840,
        7841,
        8518
    ],
    "boyawa": [
        7877
    ],
    "bats’il k’op": [
        7880
    ],
    "bats’il": [
        7880
    ],
    "bats'i k'op": [
        7888
    ],
    "bats’i k’op": [
        7888,
        7889,
        7890,
        7891
    ],
    "bats’i": [
        7888,
        7889,
        7890,
        7891
    ],
    "bikol, buhi’non": [
        7898
    ],
    "buhi’non": [
        7898
    ],
    "bikol buhi": [
        7898
    ],
    "bikol-boînën": [
        7898
    ],
    "boie’nen": [
        7898
    ],
    "boînan": [
        7898
    ],
    "boînën": [
        7898
    ],
    "buhi'non bikol": [
        7898
    ],
    "buhinon": [
        7898
    ],
    "buhi-non": [
        7898
    ],
    "benkonjo": [
        7934
    ],
    "bukpe": [
        7938
    ],
    "botteng-tappalang": [
        7952
    ],
    "benguella": [
        7957
    ],
    "banjigam": [
        7959,
        7960
    ],
    "barungguan": [
        7959,
        7960
    ],
    "barunguan": [
        7959,
        7960
    ],
    "banava": [
        7984
    ],
    "banawa": [
        7984
    ],
    "biotu": [
        7998
    ],
    "brung": [
        8016,
        8017
    ],
    "bazehai": [
        8030
    ],
    "basanga": [
        8037
    ],
    "booli": [
        8045
    ],
    "berar marathi": [
        8049
    ],
    "berar": [
        8049
    ],
    "berari": [
        8049
    ],
    "buasi": [
        8053
    ],
    "bhaipei": [
        8057
    ],
    "bambutuku": [
        8061
    ],
    "bvanuma": [
        8061
    ],
    "babar, southeast": [
        8065
    ],
    "bontok, southwestern": [
        8066
    ],
    "brasileiro": [
        8069
    ],
    "beda": [
        8070
    ],
    "bedda": [
        8070
    ],
    "bavri": [
        8076
    ],
    "bavili": [
        8083
    ],
    "bona iduna": [
        8089
    ],
    "bona": [
        8089
    ],
    "bonada": [
        8089
    ],
    "bintuhan": [
        8092
    ],
    "barbaram": [
        8105
    ],
    "balbarum": [
        8105
    ],
    "barbarem": [
        8105
    ],
    "barbarum": [
        8105
    ],
    "booburam": [
        8105
    ],
    "bagu": [
        8112
    ],
    "bartolo": [
        8118,
        9121
    ],
    "binjara": [
        8121
    ],
    "banggor": [
        8129
    ],
    "banam bay": [
        8138
    ],
    "banam": [
        8138
    ],
    "banan bay": [
        8138
    ],
    "banan": [
        8138
    ],
    "burmbar": [
        8138
    ],
    "baboute": [
        8145
    ],
    "babute": [
        8145
    ],
    "bamboute": [
        8145
    ],
    "boute": [
        8145
    ],
    "bule": [
        8145
    ],
    "bute": [
        8145
    ],
    "buti": [
        8145
    ],
    "berbai": [
        8176
    ],
    "bavwanji": [
        8180
    ],
    "beldar": [
        8188
    ],
    "bengal": [
        8190
    ],
    "bawandji": [
        8196
    ],
    "bachamal": [
        8198
    ],
    "batjamalh": [
        8198
    ],
    "baeaula": [
        8218
    ],
    "beauli": [
        8218
    ],
    "banz": [
        8220,
        8225
    ],
    "biyay": [
        8223
    ],
    "bocas pretas": [
        8240
    ],
    "barlang": [
        8257
    ],
    "bekais": [
        8258
    ],
    "baubau": [
        8263
    ],
    "bakong": [
        8316,
        8502
    ],
    "berrembeel": [
        8326
    ],
    "berta": [
        8355
    ],
    "benishangul": [
        8355
    ],
    "berthú": [
        8355
    ],
    "bambendjele": [
        8365
    ],
    "bambenga": [
        8365
    ],
    "bungu": [
        8366
    ],
    "belliman": [
        8381
    ],
    "burdekin": [
        8412
    ],
    "bactrian": [
        8413,
        8414
    ],
    "bindal": [
        8415
    ],
    "bindel": [
        8415
    ],
    "bigambal": [
        8416
    ],
    "bigambul": [
        8416
    ],
    "bigumbil": [
        8416
    ],
    "bunganditj": [
        8417
    ],
    "bak-on-date": [
        8417
    ],
    "banaditj": [
        8417
    ],
    "bangandadj": [
        8417
    ],
    "bangandidj": [
        8417
    ],
    "barconedeet": [
        8417
    ],
    "baundik": [
        8417
    ],
    "boandic": [
        8417
    ],
    "boandik": [
        8417
    ],
    "booandik": [
        8417
    ],
    "booandik-ngolo": [
        8417
    ],
    "booandki-ngolo": [
        8417
    ],
    "booganitch": [
        8417
    ],
    "booganity": [
        8417
    ],
    "boongandity": [
        8417
    ],
    "borandikngolo": [
        8417
    ],
    "buadik": [
        8417
    ],
    "buandic": [
        8417
    ],
    "buandig": [
        8417
    ],
    "buandik": [
        8417
    ],
    "buanditj": [
        8417
    ],
    "bugandity": [
        8417
    ],
    "bunganadity": [
        8417
    ],
    "bungandaetch": [
        8417
    ],
    "bungandaetcha": [
        8417
    ],
    "bungandaitj": [
        8417
    ],
    "bungandidj": [
        8417
    ],
    "bungandij": [
        8417
    ],
    "bunganditjngolo": [
        8417
    ],
    "bungandity": [
        8417
    ],
    "bung’andaetch": [
        8417
    ],
    "bunjanditj": [
        8417
    ],
    "burhwundeirtch": [
        8417
    ],
    "birrpayi": [
        8419
    ],
    "birbai": [
        8419
    ],
    "biribi": [
        8419
    ],
    "birippi": [
        8419
    ],
    "birrapee": [
        8419
    ],
    "birripai": [
        8419
    ],
    "birrpai": [
        8419
    ],
    "bripi": [
        8419
    ],
    "bolgarian": [
        8422
    ],
    "bibbulman": [
        8423
    ],
    "bajongwongi": [
        8423
    ],
    "bebleman": [
        8423
    ],
    "bibbulmun": [
        8423
    ],
    "bibilum": [
        8423
    ],
    "bibulman": [
        8423
    ],
    "bibulmun": [
        8423
    ],
    "bibuulmoun": [
        8423
    ],
    "batjala": [
        8426
    ],
    "badjela": [
        8426
    ],
    "badtala": [
        8426
    ],
    "badtjala": [
        8426
    ],
    "badyala": [
        8426
    ],
    "batyala": [
        8426
    ],
    "bidhala": [
        8426
    ],
    "butchulla": [
        8426
    ],
    "bamayo": [
        8449
    ],
    "bumayoh": [
        8449
    ],
    "batwa": [
        8452
    ],
    "boroa": [
        8452
    ],
    "bush-c": [
        8452
    ],
    "bahuana": [
        8486
    ],
    "bahwana": [
        8486
    ],
    "barauána": [
        8486
    ],
    "bakung": [
        8502
    ],
    "bakung kenya": [
        8502
    ],
    "bakung kenyah": [
        8502
    ],
    "bakgalagari": [
        8511
    ],
    "boudoum": [
        8533
    ],
    "bamileke-mengaka": [
        8536,
        8537
    ],
    "bim": [
        8541
    ],
    "bahasa isyarat malaysia": [
        8541
    ],
    "bahasa manado": [
        8542
    ],
    "beneden-tomori": [
        8555
    ],
    "bemeringal": [
        8560
    ],
    "bradjerak": [
        8560
    ],
    "brajerak": [
        8560
    ],
    "brajerang": [
        8560
    ],
    "barimaia": [
        8562
    ],
    "bailko": [
        8571
    ],
    "balgu": [
        8571
    ],
    "balygu": [
        8571
    ],
    "balyku": [
        8571
    ],
    "bikpakpam": [
        8582,
        8583
    ],
    "bidia": [
        8588
    ],
    "biria": [
        8588
    ],
    "birria": [
        8588
    ],
    "banthamurra": [
        8606
    ],
    "bundhamara": [
        8606
    ],
    "bunka-burra": [
        8606
    ],
    "bruny island tasmanian": [
        8612
    ],
    "bruny": [
        8612
    ],
    "burragorang": [
        8617
    ],
    "barker": [
        8619
    ],
    "bulawa": [
        8626
    ],
    "bouiok": [
        8644
    ],
    "baianga": [
        8665
    ],
    "betta": [
        8670,
        8671,
        8672
    ],
    "betta kurumba": [
        8670,
        8671,
        8672
    ],
    "bhashe": [
        8670,
        8671,
        8672
    ],
    "black bushman": [
        8684
    ],
    "biangil": [
        8692
    ],
    "beelia": [
        8695
    ],
    "beeloo": [
        8695
    ],
    "boro (ghana)": [
        8702
    ],
    "bangerang": [
        8713
    ],
    "banda-yangere": [
        8727
    ],
    "bebaroe": [
        8731
    ],
    "boenga ko": [
        8731
    ],
    "boenga": [
        8731
    ],
    "behie": [
        8738
    ],
    "bafou": [
        8747
    ],
    "bamileke-yemba": [
        8747
    ],
    "bokha": [
        8753,
        8856
    ],
    "black muji": [
        8753,
        8887
    ],
    "bokho": [
        8753
    ],
    "balaabe": [
        8754
    ],
    "balaaben": [
        8754
    ],
    "boritsu": [
        8754
    ],
    "bai yi": [
        8761,
        8913
    ],
    "boyela": [
        8774
    ],
    "biaksi": [
        8777
    ],
    "biksi": [
        8777
    ],
    "bulali": [
        8781
    ],
    "bulalli": [
        8781
    ],
    "baiyi": [
        8785,
        8821
    ],
    "buyang, baha": [
        8790
    ],
    "buyang": [
        8790,
        8834,
        8964,
        8898
    ],
    "baha": [
        8790,
        9000
    ],
    "baha buyang": [
        8790
    ],
    "buyang zhuang": [
        8790,
        8834,
        8964
    ],
    "boren": [
        8792
    ],
    "bozi": [
        8792,
        9043
    ],
    "boolboora": [
        8799
    ],
    "bularnu": [
        8802
    ],
    "ban roi": [
        8804
    ],
    "bitovondo": [
        8817
    ],
    "black zokhuo": [
        8819
    ],
    "baiyi ren": [
        8821
    ],
    "bongwe": [
        8822
    ],
    "buiamanambu": [
        8830
    ],
    "buyang, langnian": [
        8834
    ],
    "buozaang": [
        8834,
        8964
    ],
    "bayombe": [
        8878
    ],
    "bzj": [
        8906
    ],
    "bosanski znakovni jezik": [
        8906
    ],
    "bosnian sign language": [
        8906
    ],
    "burmese sign language": [
        8907
    ],
    "bai lolo": [
        8913
    ],
    "black hat folk": [
        8916
    ],
    "bena (nigeria)": [
        8934
    ],
    "binna": [
        8934
    ],
    "biá yë": [
        8936
    ],
    "biriin": [
        8956
    ],
    "buyang, e’ma": [
        8964
    ],
    "beri-aa": [
        8975,
        8976,
        8977
    ],
    "beria": [
        8975,
        8976,
        8977
    ],
    "bideyat": [
        8975,
        8976,
        8977
    ],
    "bilyáhab": [
        8987
    ],
    "balaibalan": [
        8996
    ],
    "berawan, central": [
        8997
    ],
    "berawan": [
        8997,
        8998,
        9002
    ],
    "batu belah": [
        8997
    ],
    "belah": [
        8997
    ],
    "berawan, east": [
        8998
    ],
    "blissymbols": [
        8999
    ],
    "bliss": [
        8999
    ],
    "blissymbolics": [
        8999
    ],
    "batui": [
        9000
    ],
    "bu (bauchi state)": [
        9001
    ],
    "berawan, west": [
        9002
    ],
    "bakinga": [
        9012
    ],
    "black zhuang": [
        9015
    ],
    "bu xiong": [
        9015
    ],
    "buyoi": [
        9016
    ],
    "beifang fangyan": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "beifang": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "beijinghua": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "bazi": [
        9043
    ],
    "bu dai": [
        9044,
        9045
    ],
    "banyi": [
        9046
    ],
    "baegwa": [
        9053
    ],
    "bagwa zimakani": [
        9053
    ],
    "bagwa": [
        9053
    ],
    "ba-shuula": [
        9074
    ],
    "bahasa daerah": [
        9077,
        9078
    ],
    "bahasa melayu": [
        9077,
        9078
    ],
    "bamitaba": [
        9104
    ],
    "badjande": [
        9108,
        9109
    ],
    "bazande": [
        9108,
        9109
    ],
    "bazenda": [
        9108,
        9109
    ],
    "ba’e": [
        9110
    ],
    "baltazar": [
        9143,
        9141
    ],
    "baltázar": [
        9143
    ],
    "bau i": [
        9146,
        9147
    ],
    "bou rau": [
        9184
    ],
    "bou": [
        9184
    ],
    "boux toj": [
        9184
    ],
    "boux": [
        9184
    ]
};
